function PlanK({ ...props }) {
	return (
		<g {...props} id="unit-k">
			<g id="furniture">
				<polyline
					points="747.58 677.84 743.11 677.84 743.11 675.58 747.58 675.58 747.58 677.84"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="469.46"
					y1="665.63"
					x2="469.46"
					y2="631.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.46"
					y1="631.74"
					x2="670.95"
					y2="631.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.95"
					y1="631.74"
					x2="670.95"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.95"
					y1="665.63"
					x2="667.26"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="664.01"
					y1="665.63"
					x2="658.58"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.33"
					y1="665.63"
					x2="649.91"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.65"
					y1="665.63"
					x2="641.23"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="637.98"
					y1="665.63"
					x2="632.56"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.3"
					y1="665.63"
					x2="623.88"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="620.63"
					y1="665.63"
					x2="615.21"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.96"
					y1="665.63"
					x2="606.53"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="603.28"
					y1="665.63"
					x2="597.86"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="594.61"
					y1="665.63"
					x2="589.18"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="585.93"
					y1="665.63"
					x2="580.51"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="577.26"
					y1="665.63"
					x2="571.83"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.58"
					y1="665.63"
					x2="563.16"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="559.91"
					y1="665.63"
					x2="554.48"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.23"
					y1="665.63"
					x2="545.81"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.55"
					y1="665.63"
					x2="537.13"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.88"
					y1="665.63"
					x2="528.46"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="516.53"
					y1="665.63"
					x2="511.11"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="507.85"
					y1="665.63"
					x2="502.43"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.18"
					y1="665.63"
					x2="493.76"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="490.5"
					y1="665.63"
					x2="485.08"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.83"
					y1="665.63"
					x2="476.41"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.15"
					y1="665.63"
					x2="469.46"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.46"
					y1="665.63"
					x2="469.46"
					y2="660.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.46"
					y1="656.87"
					x2="469.46"
					y2="651.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.46"
					y1="648.19"
					x2="469.46"
					y2="642.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.46"
					y1="639.52"
					x2="469.46"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="469.46"
					y1="634.01"
					x2="473.15"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.41"
					y1="634.01"
					x2="481.83"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.08"
					y1="634.01"
					x2="490.5"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="493.76"
					y1="634.01"
					x2="499.18"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="502.43"
					y1="634.01"
					x2="507.85"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="511.11"
					y1="634.01"
					x2="516.53"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="519.78"
					y1="634.01"
					x2="525.2"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="528.46"
					y1="634.01"
					x2="533.88"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.13"
					y1="634.01"
					x2="542.55"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.81"
					y1="634.01"
					x2="551.23"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="554.48"
					y1="634.01"
					x2="559.91"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="563.16"
					y1="634.01"
					x2="568.58"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="571.83"
					y1="634.01"
					x2="577.26"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="580.51"
					y1="634.01"
					x2="585.93"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.18"
					y1="634.01"
					x2="594.61"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.86"
					y1="634.01"
					x2="603.28"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="606.53"
					y1="634.01"
					x2="611.96"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="615.21"
					y1="634.01"
					x2="620.63"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="623.88"
					y1="634.01"
					x2="629.3"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="632.56"
					y1="634.01"
					x2="637.98"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.23"
					y1="634.01"
					x2="646.65"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="649.91"
					y1="634.01"
					x2="655.33"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="658.58"
					y1="634.01"
					x2="664.01"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="667.26"
					y1="634.01"
					x2="670.95"
					y2="634.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.95"
					y1="634.01"
					x2="670.95"
					y2="639.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.95"
					y1="642.77"
					x2="670.95"
					y2="648.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.95"
					y1="651.45"
					x2="670.95"
					y2="656.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.95"
					y1="660.12"
					x2="670.95"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.48"
					y1="409.04"
					x2="332.26"
					y2="409.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="299.29"
					y1="442.93"
					x2="293.87"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="264.59"
					y1="442.93"
					x2="259.17"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.48"
					y1="416.81"
					x2="165.48"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="165.48"
					y1="411.3"
					x2="169.16"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="172.42"
					y1="411.3"
					x2="177.84"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="181.09"
					y1="411.3"
					x2="186.52"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.77"
					y1="411.3"
					x2="195.19"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.44"
					y1="411.3"
					x2="203.87"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.12"
					y1="411.3"
					x2="212.54"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.79"
					y1="411.3"
					x2="221.22"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.47"
					y1="411.3"
					x2="229.89"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.14"
					y1="411.3"
					x2="238.57"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="241.82"
					y1="411.3"
					x2="247.24"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.5"
					y1="411.3"
					x2="255.92"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="259.17"
					y1="411.3"
					x2="264.59"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.85"
					y1="411.3"
					x2="273.27"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="276.52"
					y1="411.3"
					x2="281.94"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.2"
					y1="411.3"
					x2="290.62"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="293.87"
					y1="411.3"
					x2="299.29"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="302.55"
					y1="411.3"
					x2="307.97"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="311.22"
					y1="411.3"
					x2="316.65"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="319.9"
					y1="411.3"
					x2="325.32"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="328.57"
					y1="411.3"
					x2="332.26"
					y2="411.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.26"
					y1="411.3"
					x2="332.26"
					y2="416.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="332.26"
					y1="420.07"
					x2="332.26"
					y2="425.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="389.02 598.36 450.01 598.36 450.01 659.36 389.02 659.36 389.02 598.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="226.4 53.63 226.4 58.52 263.62 58.52 263.62 53.63 226.4 53.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="265.4 53.18 224.62 53.18 224.62 53.63 265.4 53.63 265.4 53.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="265.4"
					y1="53.63"
					x2="265.4"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.62"
					y1="53.63"
					x2="265.4"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.62"
					y1="53.18"
					x2="224.62"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.4"
					y1="53.18"
					x2="224.62"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.4"
					y1="58.52"
					x2="263.62"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.62"
					y1="53.63"
					x2="226.4"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="222.4 58.52 226.4 58.52 226.4 53.63 222.4 53.63 222.4 58.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="222.4"
					y1="53.63"
					x2="222.4"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.4"
					y1="53.63"
					x2="222.4"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.4"
					y1="58.52"
					x2="226.4"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.4"
					y1="58.52"
					x2="226.4"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="267.63 53.63 263.62 53.63 263.62 58.52 267.63 58.52 267.63 53.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="267.63"
					y1="58.52"
					x2="267.63"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.62"
					y1="58.52"
					x2="267.63"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="263.62"
					y1="53.63"
					x2="263.62"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.63"
					y1="53.63"
					x2="263.62"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.4"
					y1="54.52"
					x2="263.62"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.62 58.08 222.4 58.08 222.4 53.63 224.62 53.63 224.62 53.18 220.62 53.18 220.62 58.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.62"
					y1="53.18"
					x2="220.62"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.62"
					y1="53.18"
					x2="220.62"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.62"
					y1="53.63"
					x2="224.62"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.4"
					y1="53.63"
					x2="224.62"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.4"
					y1="58.08"
					x2="222.4"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.62"
					y1="58.08"
					x2="222.4"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="269.4 53.18 265.4 53.18 265.4 53.63 267.63 53.63 267.63 58.08 269.4 58.08 269.4 53.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="269.4"
					y1="58.08"
					x2="269.4"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.63"
					y1="58.08"
					x2="269.4"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="267.63"
					y1="53.63"
					x2="267.63"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.4"
					y1="53.63"
					x2="267.63"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="265.4"
					y1="53.18"
					x2="265.4"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.4"
					y1="53.18"
					x2="265.4"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="271.66 54.52 271.66 56.78 363.15 56.78 363.15 54.52 271.66 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="363.15"
					y1="54.52"
					x2="271.66"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="363.15"
					y1="56.78"
					x2="363.15"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.66"
					y1="56.78"
					x2="363.15"
					y2="56.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="271.66"
					y1="54.52"
					x2="271.66"
					y2="56.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.62 54.52 220.62 68.07 216.1 68.07 216.1 54.52 220.62 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.62"
					y1="68.07"
					x2="220.62"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.1"
					y1="68.07"
					x2="220.62"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.1"
					y1="54.52"
					x2="216.1"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.62"
					y1="54.52"
					x2="216.1"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="273.92 54.52 273.92 68.07 269.4 68.07 269.4 54.52 273.92 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="273.92"
					y1="68.07"
					x2="273.92"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.4"
					y1="68.07"
					x2="273.92"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="269.4"
					y1="54.52"
					x2="269.4"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="273.92"
					y1="54.52"
					x2="269.4"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="365.41 54.52 365.41 68.07 360.88 68.07 360.88 54.52 365.41 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="365.41"
					y1="68.07"
					x2="365.41"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.88"
					y1="68.07"
					x2="365.41"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="360.88"
					y1="54.52"
					x2="360.88"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.41"
					y1="54.52"
					x2="360.88"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.19 53.63 503.19 58.52 540.41 58.52 540.41 53.63 503.19 53.63"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="542.19 53.18 501.41 53.18 501.41 53.63 542.19 53.63 542.19 53.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="542.19"
					y1="53.63"
					x2="542.19"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.41"
					y1="53.63"
					x2="542.19"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.41"
					y1="53.18"
					x2="501.41"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.19"
					y1="53.18"
					x2="501.41"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.19"
					y1="58.52"
					x2="540.41"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.41"
					y1="53.63"
					x2="503.19"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="499.19 58.52 503.19 58.52 503.19 53.63 499.19 53.63 499.19 58.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="499.19"
					y1="53.63"
					x2="499.19"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.19"
					y1="53.63"
					x2="499.19"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.19"
					y1="58.52"
					x2="503.19"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.19"
					y1="58.52"
					x2="503.19"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="544.42 53.63 540.41 53.63 540.41 58.52 544.42 58.52 544.42 53.63"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="544.42"
					y1="58.52"
					x2="544.42"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.41"
					y1="58.52"
					x2="544.42"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.41"
					y1="53.63"
					x2="540.41"
					y2="58.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.42"
					y1="53.63"
					x2="540.41"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.19"
					y1="54.52"
					x2="540.41"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="497.41 58.08 499.19 58.08 499.19 53.63 501.41 53.63 501.41 53.18 497.41 53.18 497.41 58.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="497.41"
					y1="53.18"
					x2="497.41"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.41"
					y1="53.18"
					x2="497.41"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.41"
					y1="53.63"
					x2="501.41"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.19"
					y1="53.63"
					x2="501.41"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.19"
					y1="58.08"
					x2="499.19"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.41"
					y1="58.08"
					x2="499.19"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="546.2 53.18 542.19 53.18 542.19 53.63 544.42 53.63 544.42 58.08 546.2 58.08 546.2 53.18"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="546.2"
					y1="58.08"
					x2="546.2"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.42"
					y1="58.08"
					x2="546.2"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.42"
					y1="53.63"
					x2="544.42"
					y2="58.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.19"
					y1="53.63"
					x2="544.42"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="542.19"
					y1="53.18"
					x2="542.19"
					y2="53.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.2"
					y1="53.18"
					x2="542.19"
					y2="53.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="548.45 54.52 548.45 56.78 668.4 56.78 668.4 54.52 548.45 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="668.4"
					y1="54.52"
					x2="548.45"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="668.4"
					y1="56.78"
					x2="668.4"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.45"
					y1="56.78"
					x2="668.4"
					y2="56.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.45"
					y1="54.52"
					x2="548.45"
					y2="56.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="497.41 54.52 497.41 68.07 492.89 68.07 492.89 54.52 497.41 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="497.41"
					y1="68.07"
					x2="497.41"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.89"
					y1="68.07"
					x2="497.41"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.89"
					y1="54.52"
					x2="492.89"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="497.41"
					y1="54.52"
					x2="492.89"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="550.72 54.52 550.72 68.07 546.2 68.07 546.2 54.52 550.72 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="550.72"
					y1="68.07"
					x2="550.72"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.2"
					y1="68.07"
					x2="550.72"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.2"
					y1="54.52"
					x2="546.2"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="550.72"
					y1="54.52"
					x2="546.2"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="670.66 54.52 670.66 68.07 666.14 68.07 666.14 54.52 670.66 54.52"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="670.66"
					y1="68.07"
					x2="670.66"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.14"
					y1="68.07"
					x2="670.66"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="666.14"
					y1="54.52"
					x2="666.14"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.66"
					y1="54.52"
					x2="666.14"
					y2="54.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="665.63"
					x2="208.44"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="948.87"
					x2="829.33"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="829.33"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="825.94"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="948.87"
					x2="736.7"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="736.7"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="740.09"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="741.22 950 741.22 948.87 736.7 948.87 736.7 950 741.22 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="824.81 948.87 824.81 950 829.33 950 829.33 948.87 824.81 948.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="741.22 930.8 741.22 929.67 736.7 929.67 736.7 930.8 741.22 930.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="824.81 929.67 824.81 930.8 829.33 930.8 829.33 929.67 824.81 929.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="741.22"
					y1="950"
					x2="736.7"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.7"
					y1="950"
					x2="736.7"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.7"
					y1="948.87"
					x2="741.22"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.22"
					y1="948.87"
					x2="741.22"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.81"
					y1="948.87"
					x2="829.33"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.33"
					y1="948.87"
					x2="829.33"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.33"
					y1="950"
					x2="824.81"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.81"
					y1="950"
					x2="824.81"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.22"
					y1="930.8"
					x2="736.7"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.7"
					y1="930.8"
					x2="736.7"
					y2="929.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="736.7"
					y1="929.67"
					x2="741.22"
					y2="929.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.22"
					y1="929.67"
					x2="741.22"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.81"
					y1="929.67"
					x2="829.33"
					y2="929.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.33"
					y1="929.67"
					x2="829.33"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="829.33"
					y1="930.8"
					x2="824.81"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="824.81"
					y1="930.8"
					x2="824.81"
					y2="929.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="742.35 948.87 742.35 930.8 740.66 930.8 740.66 948.87 742.35 948.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="825.38 948.87 825.38 930.8 823.68 930.8 823.68 948.87 825.38 948.87"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="766.17 873.29 763.38 876.08 820.89 933.6 823.68 930.8 766.17 873.29"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="740.66"
					y1="930.8"
					x2="740.09"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.66"
					y1="948.87"
					x2="740.09"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="740.09"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.38"
					y1="930.8"
					x2="825.94"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.38"
					y1="948.87"
					x2="825.94"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="825.94"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.35"
					y1="948.87"
					x2="742.35"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="742.35"
					y1="930.8"
					x2="740.66"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.66"
					y1="930.8"
					x2="740.66"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.66"
					y1="948.87"
					x2="742.35"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.38"
					y1="948.87"
					x2="825.38"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="825.38"
					y1="930.8"
					x2="823.68"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.68"
					y1="930.8"
					x2="823.68"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.68"
					y1="948.87"
					x2="825.38"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.17"
					y1="873.29"
					x2="763.38"
					y2="876.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.38"
					y1="876.08"
					x2="820.89"
					y2="933.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.89"
					y1="933.6"
					x2="823.68"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="823.68"
					y1="930.8"
					x2="766.17"
					y2="873.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="740.09"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="740.09"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="736.7"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="930.8"
					x2="736.7"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="948.87"
					x2="736.7"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="740.09"
					y1="948.87"
					x2="736.7"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="825.94"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="825.94"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="829.33"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="930.8"
					x2="829.33"
					y2="930.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="948.87"
					x2="829.33"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="825.94"
					y1="948.87"
					x2="829.33"
					y2="948.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="670.66"
					y1="50"
					x2="670.66"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="592.8"
					x2="456.79"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="456.79"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="453.4"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="592.8"
					x2="382.24"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="382.24"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="385.63"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="592.8"
					x2="646.67"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="590.54"
					x2="643.85"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="581.5"
					x2="646.67"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="581.5"
					x2="643.85"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="592.8"
					x2="495.31"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="590.54"
					x2="498.13"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="581.5"
					x2="495.31"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="581.5"
					x2="498.13"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="380.86"
					y1="592.8"
					x2="385.63"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="592.8"
					x2="458.17"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="386.76 593.93 386.76 592.8 382.24 592.8 382.24 593.93 386.76 593.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="452.27 592.8 452.27 593.93 456.79 593.93 456.79 592.8 452.27 592.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="386.76 581.5 386.76 580.37 382.24 580.37 382.24 581.5 386.76 581.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="452.27 580.37 452.27 581.5 456.79 581.5 456.79 580.37 452.27 580.37"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="386.76"
					y1="593.93"
					x2="382.24"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.24"
					y1="593.93"
					x2="382.24"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.24"
					y1="592.8"
					x2="386.76"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.76"
					y1="592.8"
					x2="386.76"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.27"
					y1="592.8"
					x2="456.79"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.79"
					y1="592.8"
					x2="456.79"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.79"
					y1="593.93"
					x2="452.27"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.27"
					y1="593.93"
					x2="452.27"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.76"
					y1="581.5"
					x2="382.24"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.24"
					y1="581.5"
					x2="382.24"
					y2="580.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="382.24"
					y1="580.37"
					x2="386.76"
					y2="580.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.76"
					y1="580.37"
					x2="386.76"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.27"
					y1="580.37"
					x2="456.79"
					y2="580.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.79"
					y1="580.37"
					x2="456.79"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.79"
					y1="581.5"
					x2="452.27"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.27"
					y1="581.5"
					x2="452.27"
					y2="580.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="387.88 592.8 387.88 581.5 386.19 581.5 386.19 592.8 387.88 592.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="452.84 592.8 452.84 581.5 451.14 581.5 451.14 592.8 452.84 592.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="406.41 536.77 403.62 539.57 448.35 584.3 451.14 581.5 406.41 536.77"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="386.19"
					y1="581.5"
					x2="385.63"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.19"
					y1="592.8"
					x2="385.63"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="385.63"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.84"
					y1="581.5"
					x2="453.4"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.84"
					y1="592.8"
					x2="453.4"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="453.4"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.88"
					y1="592.8"
					x2="387.88"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="387.88"
					y1="581.5"
					x2="386.19"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.19"
					y1="581.5"
					x2="386.19"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="386.19"
					y1="592.8"
					x2="387.88"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.84"
					y1="592.8"
					x2="452.84"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.84"
					y1="581.5"
					x2="451.14"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.14"
					y1="581.5"
					x2="451.14"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.14"
					y1="592.8"
					x2="452.84"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="406.41"
					y1="536.77"
					x2="403.62"
					y2="539.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="403.62"
					y1="539.57"
					x2="448.35"
					y2="584.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.35"
					y1="584.3"
					x2="451.14"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.14"
					y1="581.5"
					x2="406.41"
					y2="536.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="385.63"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="385.63"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="382.24"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="581.5"
					x2="382.24"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="592.8"
					x2="382.24"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="385.63"
					y1="592.8"
					x2="382.24"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="453.4"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="453.4"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="456.79"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="581.5"
					x2="456.79"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="592.8"
					x2="456.79"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="453.4"
					y1="592.8"
					x2="456.79"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="499.82 590.54 498.69 590.54 498.69 592.8 499.82 592.8 499.82 590.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="499.82 593.93 499.82 592.8 495.31 592.8 495.31 593.93 499.82 593.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="643.28 590.54 642.15 590.54 642.15 592.8 643.28 592.8 643.28 590.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="642.15 592.8 642.15 593.93 646.67 593.93 646.67 592.8 642.15 592.8"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="499.82 581.5 499.82 578.68 495.31 578.68 495.31 581.5 499.82 581.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="642.15 578.68 642.15 581.5 646.67 581.5 646.67 578.68 642.15 578.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="499.82"
					y1="590.54"
					x2="499.82"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.82"
					y1="592.8"
					x2="498.69"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.69"
					y1="592.8"
					x2="498.69"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.69"
					y1="590.54"
					x2="499.82"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.82"
					y1="593.93"
					x2="495.31"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.31"
					y1="593.93"
					x2="495.31"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.31"
					y1="592.8"
					x2="499.82"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.82"
					y1="592.8"
					x2="499.82"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.28"
					y1="590.54"
					x2="643.28"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.28"
					y1="592.8"
					x2="642.15"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.15"
					y1="592.8"
					x2="642.15"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.15"
					y1="590.54"
					x2="643.28"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.15"
					y1="592.8"
					x2="646.67"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.67"
					y1="592.8"
					x2="646.67"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.67"
					y1="593.93"
					x2="642.15"
					y2="593.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.15"
					y1="593.93"
					x2="642.15"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.82"
					y1="581.5"
					x2="495.31"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.31"
					y1="581.5"
					x2="495.31"
					y2="578.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.31"
					y1="578.68"
					x2="499.82"
					y2="578.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="499.82"
					y1="578.68"
					x2="499.82"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.15"
					y1="578.68"
					x2="646.67"
					y2="578.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.67"
					y1="578.68"
					x2="646.67"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.67"
					y1="581.5"
					x2="642.15"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.15"
					y1="581.5"
					x2="642.15"
					y2="578.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.21 590.54 503.21 581.5 498.69 581.5 498.69 590.54 503.21 590.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="643.28 590.54 643.28 581.5 638.76 581.5 638.76 590.54 643.28 590.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="568.73 581.5 568.73 585.46 638.76 585.46 638.76 581.5 568.73 581.5"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="530.32 585.46 530.32 589.41 600.36 589.41 600.36 585.46 530.32 585.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="498.69"
					y1="581.5"
					x2="498.13"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.69"
					y1="590.54"
					x2="498.13"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.13"
					y1="581.5"
					x2="498.13"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.28"
					y1="581.5"
					x2="643.85"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.28"
					y1="590.54"
					x2="643.85"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.85"
					y1="581.5"
					x2="643.85"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.21"
					y1="590.54"
					x2="503.21"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.21"
					y1="581.5"
					x2="498.69"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.69"
					y1="581.5"
					x2="498.69"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.69"
					y1="590.54"
					x2="503.21"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.28"
					y1="590.54"
					x2="643.28"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="643.28"
					y1="581.5"
					x2="638.76"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.76"
					y1="581.5"
					x2="638.76"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.76"
					y1="590.54"
					x2="643.28"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.73"
					y1="581.5"
					x2="568.73"
					y2="585.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="568.73"
					y1="585.46"
					x2="638.76"
					y2="585.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.76"
					y1="585.46"
					x2="638.76"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.76"
					y1="581.5"
					x2="568.73"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.32"
					y1="585.46"
					x2="530.32"
					y2="589.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="530.32"
					y1="589.41"
					x2="600.36"
					y2="589.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.36"
					y1="589.41"
					x2="600.36"
					y2="585.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="600.36"
					y1="585.46"
					x2="530.32"
					y2="585.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.13"
					y1="581.5"
					x2="498.13"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="581.5"
					x2="498.13"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="590.54"
					x2="498.13"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="581.5"
					x2="495.31"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="590.54"
					x2="498.13"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="592.8"
					x2="495.31"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="498.13"
					y1="592.8"
					x2="495.31"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="581.5"
					x2="643.85"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="581.5"
					x2="643.85"
					y2="590.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="590.54"
					x2="643.85"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="581.5"
					x2="646.67"
					y2="581.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="590.54"
					x2="643.85"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="592.8"
					x2="646.67"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="643.85"
					y1="592.8"
					x2="646.67"
					y2="592.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="351.05"
					y1="467.72"
					x2="351.05"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="339.75"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="351.05"
					y2="467.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="540.01"
					x2="339.75"
					y2="543.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="540.01"
					x2="339.75"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="351.05 468.85 352.18 468.85 352.18 464.33 351.05 464.33 351.05 468.85"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="339.75 538.88 338.62 538.88 338.62 543.4 339.75 543.4 339.75 538.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="338.62 468.85 339.75 468.85 339.75 464.33 338.62 464.33 338.62 468.85"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="351.05"
					y1="468.85"
					x2="351.05"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.05"
					y1="464.33"
					x2="352.18"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.18"
					y1="464.33"
					x2="352.18"
					y2="468.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="352.18"
					y1="468.85"
					x2="351.05"
					y2="468.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="538.88"
					x2="339.75"
					y2="543.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="543.4"
					x2="338.62"
					y2="543.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.62"
					y1="543.4"
					x2="338.62"
					y2="538.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.62"
					y1="538.88"
					x2="339.75"
					y2="538.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.62"
					y1="468.85"
					x2="338.62"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="338.62"
					y1="464.33"
					x2="339.75"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="464.33"
					x2="339.75"
					y2="468.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="468.85"
					x2="338.62"
					y2="468.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="351.05 468.29 339.75 468.29 339.75 469.98 351.05 469.98 351.05 468.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="291.82 517.9 294.62 520.7 342.55 472.78 339.75 469.98 291.82 517.9"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.75"
					y1="539.45"
					x2="339.75"
					y2="540.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="468.29"
					x2="339.75"
					y2="467.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.05"
					y1="468.29"
					x2="351.05"
					y2="467.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="351.05"
					y2="467.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="537.75"
					x2="339.75"
					y2="539.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.05"
					y1="468.29"
					x2="339.75"
					y2="468.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="468.29"
					x2="339.75"
					y2="469.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="469.98"
					x2="351.05"
					y2="469.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="351.05"
					y1="469.98"
					x2="351.05"
					y2="468.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="291.82"
					y1="517.9"
					x2="294.62"
					y2="520.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="294.62"
					y1="520.7"
					x2="342.55"
					y2="472.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="342.55"
					y1="472.78"
					x2="339.75"
					y2="469.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="469.98"
					x2="291.82"
					y2="517.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="540.01"
					x2="339.75"
					y2="543.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="540.01"
					x2="339.75"
					y2="543.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="351.05"
					y2="467.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="351.05"
					y2="467.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="339.75"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="339.75"
					y1="467.72"
					x2="339.75"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="351.05"
					y1="467.72"
					x2="351.05"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="351.05"
					y1="467.72"
					x2="351.05"
					y2="464.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="454.23"
					x2="458.8"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="458.8"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="455.41"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="454.23"
					x2="379.73"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="379.73"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="383.12"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="384.25 455.36 384.25 454.23 379.73 454.23 379.73 455.36 384.25 455.36"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="454.28 454.23 454.28 455.36 458.8 455.36 458.8 454.23 454.28 454.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="384.25 442.93 384.25 441.8 379.73 441.8 379.73 442.93 384.25 442.93"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="454.28 441.8 454.28 442.93 458.8 442.93 458.8 441.8 454.28 441.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="384.25"
					y1="455.36"
					x2="379.73"
					y2="455.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.73"
					y1="455.36"
					x2="379.73"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.73"
					y1="454.23"
					x2="384.25"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.25"
					y1="454.23"
					x2="384.25"
					y2="455.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.28"
					y1="454.23"
					x2="458.8"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.8"
					y1="454.23"
					x2="458.8"
					y2="455.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.8"
					y1="455.36"
					x2="454.28"
					y2="455.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.28"
					y1="455.36"
					x2="454.28"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.25"
					y1="442.93"
					x2="379.73"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.73"
					y1="442.93"
					x2="379.73"
					y2="441.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="379.73"
					y1="441.8"
					x2="384.25"
					y2="441.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="384.25"
					y1="441.8"
					x2="384.25"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.28"
					y1="441.8"
					x2="458.8"
					y2="441.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.8"
					y1="441.8"
					x2="458.8"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.8"
					y1="442.93"
					x2="454.28"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.28"
					y1="442.93"
					x2="454.28"
					y2="441.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="385.38 454.23 385.38 442.93 383.68 442.93 383.68 454.23 385.38 454.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="454.85 454.23 454.85 442.93 453.15 442.93 453.15 454.23 454.85 454.23"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="405.23 395 402.43 397.8 450.36 445.73 453.15 442.93 405.23 395"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="383.68"
					y1="442.93"
					x2="383.12"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.68"
					y1="454.23"
					x2="383.12"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="383.12"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.85"
					y1="442.93"
					x2="455.41"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.85"
					y1="454.23"
					x2="455.41"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="455.41"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.38"
					y1="454.23"
					x2="385.38"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="385.38"
					y1="442.93"
					x2="383.68"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.68"
					y1="442.93"
					x2="383.68"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.68"
					y1="454.23"
					x2="385.38"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.85"
					y1="454.23"
					x2="454.85"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.85"
					y1="442.93"
					x2="453.15"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.15"
					y1="442.93"
					x2="453.15"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.15"
					y1="454.23"
					x2="454.85"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="405.23"
					y1="395"
					x2="402.43"
					y2="397.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="402.43"
					y1="397.8"
					x2="450.36"
					y2="445.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.36"
					y1="445.73"
					x2="453.15"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.15"
					y1="442.93"
					x2="405.23"
					y2="395"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="383.12"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="383.12"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="379.73"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="442.93"
					x2="379.73"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="454.23"
					x2="379.73"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="383.12"
					y1="454.23"
					x2="379.73"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="455.41"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="455.41"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="458.8"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="442.93"
					x2="458.8"
					y2="442.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="454.23"
					x2="458.8"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="455.41"
					y1="454.23"
					x2="458.8"
					y2="454.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="390.58"
					x2="185.2"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="388.32"
					x2="188.02"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="379.28"
					x2="185.2"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="379.28"
					x2="188.02"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="390.58"
					x2="320.75"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="388.32"
					x2="317.92"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="379.28"
					x2="320.75"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="379.28"
					x2="317.92"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="343.55"
					y1="379.28"
					x2="317.92"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="390.58"
					x2="332.26"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="316.23 388.32 316.23 390.58 317.36 390.58 317.36 388.32 316.23 388.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="316.23 391.71 320.75 391.71 320.75 390.58 316.23 390.58 316.23 391.71"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="188.58 388.32 188.58 390.58 189.71 390.58 189.71 388.32 188.58 388.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="189.71 390.58 185.2 390.58 185.2 391.71 189.71 391.71 189.71 390.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="316.23 379.28 320.75 379.28 320.75 376.46 316.23 376.46 316.23 379.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="189.71 376.46 185.2 376.46 185.2 379.28 189.71 379.28 189.71 376.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="316.23"
					y1="388.32"
					x2="316.23"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.23"
					y1="390.58"
					x2="317.36"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.36"
					y1="390.58"
					x2="317.36"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.36"
					y1="388.32"
					x2="316.23"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.23"
					y1="391.71"
					x2="320.75"
					y2="391.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.75"
					y1="391.71"
					x2="320.75"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.75"
					y1="390.58"
					x2="316.23"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.23"
					y1="390.58"
					x2="316.23"
					y2="391.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.58"
					y1="388.32"
					x2="188.58"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.58"
					y1="390.58"
					x2="189.71"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="390.58"
					x2="189.71"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="388.32"
					x2="188.58"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="390.58"
					x2="185.2"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.2"
					y1="390.58"
					x2="185.2"
					y2="391.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.2"
					y1="391.71"
					x2="189.71"
					y2="391.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="391.71"
					x2="189.71"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.23"
					y1="379.28"
					x2="320.75"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.75"
					y1="379.28"
					x2="320.75"
					y2="376.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="320.75"
					y1="376.46"
					x2="316.23"
					y2="376.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="316.23"
					y1="376.46"
					x2="316.23"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="376.46"
					x2="185.2"
					y2="376.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.2"
					y1="376.46"
					x2="185.2"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="185.2"
					y1="379.28"
					x2="189.71"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="379.28"
					x2="189.71"
					y2="376.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="312.84 388.32 317.36 388.32 317.36 379.28 312.84 379.28 312.84 388.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="188.58 388.32 193.1 388.32 193.1 379.28 188.58 379.28 188.58 388.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="255.23 379.28 193.1 379.28 193.1 383.23 255.23 383.23 255.23 379.28"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="285.73 383.23 223.6 383.23 223.6 387.19 285.73 387.19 285.73 383.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="317.36"
					y1="379.28"
					x2="317.92"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.36"
					y1="388.32"
					x2="317.92"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.92"
					y1="379.28"
					x2="317.92"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.58"
					y1="379.28"
					x2="188.02"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.58"
					y1="388.32"
					x2="188.02"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.02"
					y1="379.28"
					x2="188.02"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.84"
					y1="388.32"
					x2="312.84"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="312.84"
					y1="379.28"
					x2="317.36"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.36"
					y1="379.28"
					x2="317.36"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.36"
					y1="388.32"
					x2="312.84"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.58"
					y1="388.32"
					x2="188.58"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.58"
					y1="379.28"
					x2="193.1"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.1"
					y1="379.28"
					x2="193.1"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.1"
					y1="388.32"
					x2="188.58"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.23"
					y1="379.28"
					x2="255.23"
					y2="383.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="255.23"
					y1="383.23"
					x2="193.1"
					y2="383.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.1"
					y1="383.23"
					x2="193.1"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.1"
					y1="379.28"
					x2="255.23"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.73"
					y1="383.23"
					x2="285.73"
					y2="387.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="285.73"
					y1="387.19"
					x2="223.6"
					y2="387.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.6"
					y1="387.19"
					x2="223.6"
					y2="383.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.6"
					y1="383.23"
					x2="285.73"
					y2="383.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="317.92"
					y1="379.28"
					x2="317.92"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="379.28"
					x2="317.92"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="388.32"
					x2="317.92"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="379.28"
					x2="320.75"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="388.32"
					x2="317.92"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="390.58"
					x2="320.75"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="317.92"
					y1="390.58"
					x2="320.75"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="379.28"
					x2="188.02"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="379.28"
					x2="188.02"
					y2="388.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="388.32"
					x2="188.02"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="379.28"
					x2="185.2"
					y2="379.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="388.32"
					x2="188.02"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="390.58"
					x2="185.2"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="188.02"
					y1="390.58"
					x2="185.2"
					y2="390.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="458.17"
					y1="592.8"
					x2="458.17"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="208.44"
					y1="665.63"
					x2="208.44"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="208.44"
					y1="593.36"
					x2="188.81"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="365.41"
					y1="50"
					x2="365.41"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="492.89"
					y1="68.07"
					x2="492.89"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<line
					x1="216.1"
					y1="68.07"
					x2="216.1"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".38"
				/>
				<polyline
					points="208.44 593.36 208.44 665.63 339.75 665.63 339.75 593.36 208.44 593.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="339.75"
					y1="593.36"
					x2="208.44"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="339.75"
					y1="665.63"
					x2="339.75"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.44"
					y1="665.63"
					x2="339.75"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="208.44"
					y1="593.36"
					x2="208.44"
					y2="665.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="216.67 601.91 216.67 656.12 330.96 656.12 330.96 601.91 216.67 601.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="330.96"
					y1="601.91"
					x2="216.67"
					y2="601.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="330.96"
					y1="656.12"
					x2="330.96"
					y2="601.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.67"
					y1="656.12"
					x2="330.96"
					y2="656.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.67"
					y1="601.91"
					x2="216.67"
					y2="656.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="227.9 629.49 227.86 629.01 227.75 628.54 227.56 628.09 227.31 627.69 227 627.35 226.65 627.07 226.25 626.86 225.83 626.73 225.39 626.69 224.96 626.73 224.53 626.86 224.14 627.07 223.78 627.35 223.47 627.69 223.22 628.09 223.04 628.54 222.92 629.01 222.88 629.49 222.92 629.98 223.04 630.45 223.22 630.9 223.47 631.3 223.78 631.64 224.14 631.92 224.53 632.13 224.96 632.25 225.39 632.3 225.83 632.25 226.25 632.13 226.65 631.92 227 631.64 227.31 631.3 227.56 630.9 227.75 630.45 227.86 629.98 227.9 629.49"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="227.86"
					y1="629.98"
					x2="227.9"
					y2="629.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.75"
					y1="630.45"
					x2="227.86"
					y2="629.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.56"
					y1="630.9"
					x2="227.75"
					y2="630.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.31"
					y1="631.3"
					x2="227.56"
					y2="630.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227"
					y1="631.64"
					x2="227.31"
					y2="631.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.65"
					y1="631.92"
					x2="227"
					y2="631.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.25"
					y1="632.13"
					x2="226.65"
					y2="631.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.83"
					y1="632.25"
					x2="226.25"
					y2="632.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.39"
					y1="632.3"
					x2="225.83"
					y2="632.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.96"
					y1="632.25"
					x2="225.39"
					y2="632.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.53"
					y1="632.13"
					x2="224.96"
					y2="632.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.14"
					y1="631.92"
					x2="224.53"
					y2="632.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.78"
					y1="631.64"
					x2="224.14"
					y2="631.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.47"
					y1="631.3"
					x2="223.78"
					y2="631.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.22"
					y1="630.9"
					x2="223.47"
					y2="631.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.04"
					y1="630.45"
					x2="223.22"
					y2="630.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.92"
					y1="629.98"
					x2="223.04"
					y2="630.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.88"
					y1="629.49"
					x2="222.92"
					y2="629.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.92"
					y1="629.01"
					x2="222.88"
					y2="629.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.04"
					y1="628.54"
					x2="222.92"
					y2="629.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.22"
					y1="628.09"
					x2="223.04"
					y2="628.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.47"
					y1="627.69"
					x2="223.22"
					y2="628.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.78"
					y1="627.35"
					x2="223.47"
					y2="627.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.14"
					y1="627.07"
					x2="223.78"
					y2="627.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.53"
					y1="626.86"
					x2="224.14"
					y2="627.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.96"
					y1="626.73"
					x2="224.53"
					y2="626.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.39"
					y1="626.69"
					x2="224.96"
					y2="626.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.83"
					y1="626.73"
					x2="225.39"
					y2="626.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.25"
					y1="626.86"
					x2="225.83"
					y2="626.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="226.65"
					y1="627.07"
					x2="226.25"
					y2="626.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227"
					y1="627.35"
					x2="226.65"
					y2="627.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.31"
					y1="627.69"
					x2="227"
					y2="627.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.56"
					y1="628.09"
					x2="227.31"
					y2="627.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.75"
					y1="628.54"
					x2="227.56"
					y2="628.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.86"
					y1="629.01"
					x2="227.75"
					y2="628.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.9"
					y1="629.49"
					x2="227.86"
					y2="629.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="213.73 631.91 213.36 631.87 212.99 631.77 212.65 631.59 212.34 631.35 212.08 631.05 211.86 630.7 211.7 630.32 211.6 629.91 211.57 629.49 211.6 629.08 211.7 628.67 211.86 628.29 212.08 627.94 212.34 627.64 212.65 627.4 212.99 627.22 213.36 627.11 213.73 627.08 217.36 627.46 217.65 627.52 217.93 627.62 218.19 627.78 222.77 628.42 222.93 628.46 223.08 628.53 223.22 628.62 223.34 628.75 223.45 628.89 223.53 629.05 223.58 629.22 223.61 629.4 223.61 629.59 223.58 629.77 223.53 629.94 223.45 630.1 223.34 630.24 223.22 630.36 223.08 630.46 222.93 630.53 222.77 630.57 218.19 631.21 217.93 631.36 217.65 631.47 217.36 631.52 213.73 631.91"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="213.73"
					y1="631.91"
					x2="217.36"
					y2="631.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="218.19"
					y1="631.21"
					x2="222.77"
					y2="630.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="222.77"
					y1="628.42"
					x2="218.19"
					y2="627.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.36"
					y1="627.46"
					x2="213.73"
					y2="627.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.89"
					y1="628.18"
					x2="217.18"
					y2="628.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.18"
					y1="630.81"
					x2="215.89"
					y2="630.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.89"
					y1="630.81"
					x2="215.89"
					y2="628.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m218.19,631.21c-.25.18-.53.29-.82.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m222.77,628.42c.48.06.85.53.85,1.07s-.36,1.01-.85,1.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m217.36,627.46c.29.03.58.14.82.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m213.73,631.91c-1.19,0-2.16-1.08-2.16-2.42s.97-2.42,2.16-2.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m217.18,628.18c.65,0,1.18.59,1.18,1.32s-.53,1.32-1.18,1.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m218.19,627.78c.52.38.84,1.02.84,1.71s-.32,1.34-.84,1.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="233.97 535.57 188.81 535.57 188.81 593.36 233.97 593.36 233.97 535.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="233.97"
					y1="535.57"
					x2="233.97"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.81"
					y1="535.57"
					x2="188.81"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.97"
					y1="593.36"
					x2="188.81"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="233.97"
					y1="535.57"
					x2="188.81"
					y2="535.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.59"
					y1="535.57"
					x2="190.59"
					y2="593.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.25"
					y1="541.87"
					x2="223.25"
					y2="587.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="223.25"
					y1="587.06"
					x2="196.14"
					y2="587.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.14"
					y1="587.06"
					x2="196.14"
					y2="541.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.14"
					y1="541.87"
					x2="223.25"
					y2="541.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.03"
					y1="540.09"
					x2="225.03"
					y2="588.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.03"
					y1="588.84"
					x2="194.36"
					y2="588.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.36"
					y1="588.84"
					x2="194.36"
					y2="540.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.36"
					y1="540.09"
					x2="225.03"
					y2="540.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m204.93,564.46c0-1.47-1.19-2.67-2.67-2.67s-2.67,1.19-2.67,2.67,1.19,2.67,2.67,2.67,2.67-1.19,2.67-2.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="191.25 562.24 194.98 562.6 195.83 562.89 200.53 563.47 201.16 563.81 201.41 564.46 201.16 565.12 200.53 565.45 195.83 566.04 194.98 566.33 191.25 566.69 189.94 566.26 189.13 565.15 189.13 563.78 189.94 562.67 191.25 562.24"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="191.25"
					y1="562.24"
					x2="194.98"
					y2="562.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m194.98,562.6c.3.03.59.13.85.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.83"
					y1="562.89"
					x2="200.53"
					y2="563.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m200.53,563.47c.5.06.87.49.87.99s-.37.92-.87.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.53"
					y1="565.45"
					x2="195.83"
					y2="566.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m195.83,566.04c-.25.16-.54.26-.85.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.98"
					y1="566.33"
					x2="191.25"
					y2="566.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m191.25,566.69c-1.23,0-2.22-1-2.22-2.22s1-2.22,2.22-2.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.46"
					y1="565.67"
					x2="194.79"
					y2="565.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.79"
					y1="563.25"
					x2="193.46"
					y2="563.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.46"
					y1="563.25"
					x2="193.46"
					y2="565.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m194.79,563.25c.67,0,1.21.54,1.21,1.21s-.54,1.21-1.21,1.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m195.83,562.89c.54.35.86.94.86,1.58s-.32,1.23-.86,1.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="248.14 505.8 249.46 503.16 250.28 500.33 250.56 497.39 250.28 494.46 249.46 491.62 248.14 488.99 246.69 487.16 244.96 485.59 242.99 484.32 239.71 482.83 236.27 481.76 232.94 481.07 229.55 480.82 226.16 481.03 222.82 481.68 219.6 482.76 215.87 482.77 212.19 482.14 208.67 480.89 205.42 479.05 203.51 477.83 201.62 476.92 199.59 476.4 197.49 476.3 195.41 476.62 193.77 477.26 189.38 477.26 189.38 479.09 191.38 479.09 190.03 481.07 189.16 483.29 188.81 485.66 188.81 509.13 189.14 511.47 190.03 513.66 191.43 515.57 193.26 517.07 195.4 518.08 197.72 518.53 198.26 518.53 199.69 518.4 201.09 518.06 203.39 517.03 205.53 515.68 208.74 513.86 212.21 512.62 215.85 511.99 219.55 512 222.78 513.1 226.12 513.75 229.53 513.96 232.93 513.72 236.27 513.03 239.71 511.96 242.99 510.47 244.96 509.2 246.69 507.63 248.14 505.8"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="209.67"
					y1="489.03"
					x2="209.67"
					y2="505.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.81"
					y1="509.13"
					x2="188.81"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.65"
					y1="509.13"
					x2="189.65"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.81"
					y1="485.66"
					x2="188.81"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.65"
					y1="485.66"
					x2="189.65"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.67"
					y1="505.32"
					x2="206.55"
					y2="505.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.55"
					y1="505.32"
					x2="206.55"
					y2="502.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.55"
					y1="502.74"
					x2="209.67"
					y2="502.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="209.67"
					y1="489.46"
					x2="206.55"
					y2="489.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.55"
					y1="489.46"
					x2="206.55"
					y2="492.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.55"
					y1="492.05"
					x2="209.67"
					y2="492.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.15"
					y1="479.09"
					x2="189.38"
					y2="479.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.15"
					y1="477.26"
					x2="189.38"
					y2="477.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.38"
					y1="477.26"
					x2="189.38"
					y2="479.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.15"
					y1="477.26"
					x2="197.15"
					y2="479.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.56"
					y1="497.39"
					x2="250.24"
					y2="500.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.24"
					y1="500.2"
					x2="249.52"
					y2="502.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.52"
					y1="502.91"
					x2="248.14"
					y2="505.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.14"
					y1="505.8"
					x2="245.86"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.86"
					y1="508.45"
					x2="242.99"
					y2="510.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.99"
					y1="510.46"
					x2="239.73"
					y2="511.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.73"
					y1="511.95"
					x2="236.27"
					y2="513.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.27"
					y1="513.03"
					x2="230.67"
					y2="514"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.67"
					y1="514"
					x2="227.85"
					y2="514.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.85"
					y1="514.05"
					x2="225.04"
					y2="513.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.04"
					y1="513.74"
					x2="220.68"
					y2="512.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.68"
					y1="512.47"
					x2="216.46"
					y2="510.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.46"
					y1="510.49"
					x2="212.68"
					y2="508.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.68"
					y1="508.14"
					x2="209.67"
					y2="505.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.55"
					y1="512"
					x2="215.63"
					y2="512.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.63"
					y1="512.03"
					x2="211.82"
					y2="512.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.82"
					y1="512.67"
					x2="207.73"
					y2="514.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.73"
					y1="514.29"
					x2="201.71"
					y2="517.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.71"
					y1="517.84"
					x2="198.72"
					y2="518.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.72"
					y1="518.51"
					x2="195.74"
					y2="518.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.74"
					y1="518.26"
					x2="193.03"
					y2="517.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.03"
					y1="517.1"
					x2="190.85"
					y2="515.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.85"
					y1="515.05"
					x2="189.74"
					y2="513.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.74"
					y1="513.05"
					x2="189.13"
					y2="511.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.13"
					y1="511.13"
					x2="188.81"
					y2="509.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.65"
					y1="509.13"
					x2="190.31"
					y2="511.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.31"
					y1="511.87"
					x2="191.69"
					y2="513.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.69"
					y1="513.5"
					x2="193.6"
					y2="514.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.6"
					y1="514.52"
					x2="196.12"
					y2="515.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.12"
					y1="515.01"
					x2="198.71"
					y2="515.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.71"
					y1="515.12"
					x2="200.01"
					y2="515.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.01"
					y1="515.1"
					x2="201.03"
					y2="514.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.03"
					y1="514.56"
					x2="201.33"
					y2="513.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.33"
					y1="513.92"
					x2="203.34"
					y2="506.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.34"
					y1="506.82"
					x2="203.94"
					y2="503.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.94"
					y1="503.29"
					x2="204.2"
					y2="499.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.2"
					y1="499.72"
					x2="204.2"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="219.6"
					y1="482.76"
					x2="215.67"
					y2="482.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="215.67"
					y1="482.73"
					x2="211.85"
					y2="482.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="211.85"
					y1="482.09"
					x2="207.73"
					y2="480.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="207.73"
					y1="480.49"
					x2="201.71"
					y2="476.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.71"
					y1="476.94"
					x2="199.72"
					y2="476.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="199.72"
					y1="476.39"
					x2="197.66"
					y2="476.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.66"
					y1="476.26"
					x2="195.65"
					y2="476.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="195.65"
					y1="476.55"
					x2="193.77"
					y2="477.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.65"
					y1="485.66"
					x2="190.31"
					y2="482.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.31"
					y1="482.92"
					x2="191.69"
					y2="481.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.69"
					y1="481.29"
					x2="193.6"
					y2="480.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="193.6"
					y1="480.27"
					x2="196.12"
					y2="479.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.12"
					y1="479.78"
					x2="198.71"
					y2="479.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="198.71"
					y1="479.67"
					x2="200.01"
					y2="479.69"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="200.01"
					y1="479.69"
					x2="201.03"
					y2="480.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.03"
					y1="480.23"
					x2="201.33"
					y2="480.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="201.33"
					y1="480.86"
					x2="203.34"
					y2="487.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.34"
					y1="487.96"
					x2="203.94"
					y2="491.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.94"
					y1="491.49"
					x2="204.2"
					y2="495.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.2"
					y1="495.06"
					x2="204.2"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.56"
					y1="497.39"
					x2="250.24"
					y2="494.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="250.24"
					y1="494.59"
					x2="249.52"
					y2="491.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="249.52"
					y1="491.88"
					x2="248.14"
					y2="488.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="248.14"
					y1="488.99"
					x2="245.86"
					y2="486.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="245.86"
					y1="486.33"
					x2="242.99"
					y2="484.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="242.99"
					y1="484.32"
					x2="239.73"
					y2="482.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="239.73"
					y1="482.84"
					x2="236.27"
					y2="481.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="236.27"
					y1="481.76"
					x2="230.67"
					y2="480.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="230.67"
					y1="480.79"
					x2="227.85"
					y2="480.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="227.85"
					y1="480.74"
					x2="225.04"
					y2="481.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.04"
					y1="481.05"
					x2="220.68"
					y2="482.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.68"
					y1="482.32"
					x2="216.46"
					y2="484.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.46"
					y1="484.3"
					x2="212.68"
					y2="486.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="212.68"
					y1="486.65"
					x2="209.67"
					y2="489.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.34"
					y1="517.06"
					x2="203.98"
					y2="516.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.98"
					y1="516.61"
					x2="204.93"
					y2="515.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.93"
					y1="515.32"
					x2="205.15"
					y2="514.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.15"
					y1="514.2"
					x2="205.77"
					y2="506.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.77"
					y1="506.99"
					x2="206.05"
					y2="499.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.05"
					y1="499.76"
					x2="206.05"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.34"
					y1="477.73"
					x2="203.98"
					y2="478.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="203.98"
					y1="478.18"
					x2="204.93"
					y2="479.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="204.93"
					y1="479.47"
					x2="205.15"
					y2="480.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.15"
					y1="480.59"
					x2="205.77"
					y2="487.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="205.77"
					y1="487.8"
					x2="206.05"
					y2="495.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="206.05"
					y1="495.03"
					x2="206.05"
					y2="497.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="191.38"
					y1="479.09"
					x2="190.85"
					y2="479.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="190.85"
					y1="479.74"
					x2="189.74"
					y2="481.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.74"
					y1="481.74"
					x2="189.13"
					y2="483.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.13"
					y1="483.66"
					x2="188.81"
					y2="485.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="519.99"
					x2="188.81"
					y2="519.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="188.81 470.28 188.81 474.8 189.71 474.8 189.71 470.28 188.81 470.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="189.71"
					y1="470.28"
					x2="188.81"
					y2="470.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="474.8"
					x2="189.71"
					y2="470.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.81"
					y1="474.8"
					x2="189.71"
					y2="474.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="188.81"
					y1="470.28"
					x2="188.81"
					y2="474.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="189.71 522.7 197.06 522.7 197.06 521.79 189.71 521.79 189.71 522.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="189.71"
					y1="521.79"
					x2="189.71"
					y2="522.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.06"
					y1="521.79"
					x2="189.71"
					y2="521.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.06"
					y1="522.7"
					x2="197.06"
					y2="521.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="522.7"
					x2="197.06"
					y2="522.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="189.71 472.09 189.71 473 197.06 473 197.06 472.09 189.71 472.09"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="197.06"
					y1="472.09"
					x2="189.71"
					y2="472.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="197.06"
					y1="473"
					x2="197.06"
					y2="472.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="473"
					x2="197.06"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="189.71"
					y1="472.09"
					x2="189.71"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="194.8 521.79 196.61 521.79 196.61 473 194.8 473 194.8 521.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="194.8"
					y1="473"
					x2="194.8"
					y2="521.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.61"
					y1="473"
					x2="194.8"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="196.61"
					y1="521.79"
					x2="196.61"
					y2="473"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="194.8"
					y1="521.79"
					x2="196.61"
					y2="521.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.58"
					y1="749.61"
					x2="747.58"
					y2="673.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.21"
					y1="749.61"
					x2="747.58"
					y2="749.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="831.58"
					y1="673.32"
					x2="747.94"
					y2="673.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="753.22"
					y1="749.61"
					x2="753.22"
					y2="673.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="758.62 508.89 810.18 508.89 810.18 458.23 758.62 458.23 758.62 508.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="758.62"
					y1="458.23"
					x2="758.62"
					y2="460.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="463.5"
					x2="758.62"
					y2="468.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="472.17"
					x2="758.62"
					y2="477.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="480.85"
					x2="758.62"
					y2="486.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="489.53"
					x2="758.62"
					y2="494.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="498.2"
					x2="758.62"
					y2="503.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="506.88"
					x2="758.62"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="458.23"
					x2="807.72"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.46"
					y1="458.23"
					x2="799.04"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.79"
					y1="458.23"
					x2="790.36"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.11"
					y1="458.23"
					x2="781.69"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="778.44"
					y1="458.23"
					x2="773.01"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.76"
					y1="458.23"
					x2="764.34"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="761.08"
					y1="458.23"
					x2="758.62"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="508.89"
					x2="810.18"
					y2="506.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="503.62"
					x2="810.18"
					y2="498.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="494.95"
					x2="810.18"
					y2="489.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="486.27"
					x2="810.18"
					y2="480.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="477.6"
					x2="810.18"
					y2="472.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="468.92"
					x2="810.18"
					y2="463.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="460.24"
					x2="810.18"
					y2="458.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="508.89"
					x2="761.08"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.34"
					y1="508.89"
					x2="769.76"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="773.01"
					y1="508.89"
					x2="778.44"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="781.69"
					y1="508.89"
					x2="787.11"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="790.36"
					y1="508.89"
					x2="795.79"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.04"
					y1="508.89"
					x2="804.46"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="807.72"
					y1="508.89"
					x2="810.18"
					y2="508.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="755.96 458.42 754.4 458.42 754.4 508.7 755.96 508.7 755.96 500.81 754.68 500.81 754.68 466.31 755.96 466.31 755.96 458.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="755.96"
					y1="466.31"
					x2="755.96"
					y2="458.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="754.68"
					y1="466.31"
					x2="755.96"
					y2="466.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="754.68"
					y1="500.81"
					x2="754.68"
					y2="466.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="755.96"
					y1="500.81"
					x2="754.68"
					y2="500.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="755.96"
					y1="508.7"
					x2="755.96"
					y2="500.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="754.4"
					y1="508.7"
					x2="755.96"
					y2="508.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="754.4"
					y1="458.42"
					x2="754.4"
					y2="508.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="755.96"
					y1="458.42"
					x2="754.4"
					y2="458.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<polyline
					points="755.96 456.45 755.96 510.67 758.62 510.67 758.62 456.45 755.96 456.45"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="758.62"
					y1="456.45"
					x2="755.96"
					y2="456.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="758.62"
					y1="510.67"
					x2="758.62"
					y2="456.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="755.96"
					y1="510.67"
					x2="758.62"
					y2="510.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="755.96"
					y1="456.45"
					x2="755.96"
					y2="510.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".27"
				/>
				<line
					x1="755.96"
					y1="508.7"
					x2="754.4"
					y2="508.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.4"
					y1="508.7"
					x2="754.4"
					y2="458.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.4"
					y1="458.42"
					x2="755.96"
					y2="458.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.96"
					y1="510.67"
					x2="755.96"
					y2="456.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.96"
					y1="466.31"
					x2="754.68"
					y2="466.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.68"
					y1="466.31"
					x2="754.68"
					y2="500.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.68"
					y1="500.81"
					x2="755.96"
					y2="500.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="510.67"
					x2="755.96"
					y2="510.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="755.96"
					y1="456.45"
					x2="758.62"
					y2="456.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="456.45"
					x2="758.62"
					y2="510.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="754.11 580.11 754.11 647.88 812.84 647.88 812.84 580.11 754.11 580.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="754.11"
					y1="580.11"
					x2="754.11"
					y2="647.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="812.84"
					y1="580.11"
					x2="812.84"
					y2="647.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="811.06"
					y1="580.11"
					x2="811.06"
					y2="647.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.11"
					y1="580.11"
					x2="812.84"
					y2="580.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="754.11"
					y1="647.88"
					x2="812.84"
					y2="647.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.77"
					y1="584.55"
					x2="756.77"
					y2="643.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="756.77"
					y1="643.43"
					x2="758.55"
					y2="645.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.55"
					y1="645.21"
					x2="808.4"
					y2="645.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.4"
					y1="645.21"
					x2="810.18"
					y2="643.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="643.43"
					x2="810.18"
					y2="584.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="810.18"
					y1="584.55"
					x2="808.4"
					y2="582.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="808.4"
					y1="582.78"
					x2="758.55"
					y2="582.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.55"
					y1="582.78"
					x2="756.77"
					y2="584.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m777.69,597.05c0-4.91-3.98-8.9-8.9-8.9s-8.89,3.98-8.89,8.9,3.98,8.9,8.89,8.9,8.9-3.98,8.9-8.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m804.83,597.05c0-3.68-2.98-6.67-6.67-6.67s-6.67,2.99-6.67,6.67,2.99,6.67,6.67,6.67,6.67-2.99,6.67-6.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m775.46,630.94c0-3.68-2.99-6.67-6.67-6.67s-6.67,2.99-6.67,6.67,2.98,6.67,6.67,6.67,6.67-2.99,6.67-6.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m807.05,630.94c0-4.91-3.98-8.9-8.89-8.9s-8.9,3.98-8.9,8.9,3.98,8.9,8.9,8.9,8.89-3.98,8.89-8.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="765.12 518.06 765.12 574.33 765.64 575.59 766.9 576.11 804.57 576.11 805.83 575.59 806.35 574.33 806.35 518.06 805.83 516.8 804.57 516.28 766.9 516.28 765.64 516.8 765.12 518.06"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m765.12,518.06c0-.98.8-1.78,1.78-1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.57"
					y1="516.28"
					x2="766.9"
					y2="516.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m804.57,516.28c.98,0,1.78.79,1.78,1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="806.35"
					y1="574.33"
					x2="806.35"
					y2="518.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m806.35,574.33c0,.98-.79,1.78-1.78,1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="766.9"
					y1="576.11"
					x2="804.57"
					y2="576.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m766.9,576.11c-.98,0-1.78-.79-1.78-1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.12"
					y1="518.06"
					x2="765.12"
					y2="574.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.57"
					y1="522.51"
					x2="769.57"
					y2="569.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="771.35"
					y1="571.66"
					x2="795.68"
					y2="571.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="797.46"
					y1="569.88"
					x2="797.46"
					y2="522.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.68"
					y1="520.73"
					x2="771.35"
					y2="520.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="769.57"
					y1="522.51"
					x2="769.57"
					y2="522.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m771.35,571.66c-.98,0-1.78-.79-1.78-1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m797.46,569.88c0,.98-.8,1.78-1.78,1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m795.68,520.73c.98,0,1.78.79,1.78,1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m769.57,522.51c0-.98.8-1.78,1.78-1.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m791.23,546.19c0-1.47-1.19-2.66-2.67-2.66s-2.67,1.19-2.67,2.66,1.19,2.67,2.67,2.67,2.67-1.19,2.67-2.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="786.08 545.39 785.52 545.63 785.28 546.2 785.52 546.76 786.08 546.99 803.68 546.99 804.25 546.76 804.48 546.19 804.25 545.63 803.68 545.39 786.08 545.39"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="803.68"
					y1="545.39"
					x2="786.08"
					y2="545.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m803.68,545.39c.44,0,.8.36.8.8s-.36.8-.8.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.08"
					y1="546.99"
					x2="803.68"
					y2="546.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m786.08,546.99h0c-.44,0-.8-.36-.8-.8s.36-.8.8-.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="799.15 544.42 799.15 545.39 803.68 545.39 804.25 545.63 804.48 546.19 804.25 546.76 803.68 546.99 799.15 546.99 799.15 547.97 804.93 547.97 804.93 544.42 799.15 544.42"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="804.93"
					y1="544.42"
					x2="799.15"
					y2="544.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="804.93"
					y1="547.97"
					x2="804.93"
					y2="544.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.15"
					y1="547.97"
					x2="804.93"
					y2="547.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.15"
					y1="546.99"
					x2="799.15"
					y2="547.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="803.68"
					y1="546.99"
					x2="799.15"
					y2="546.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m803.68,545.39c.44,0,.8.36.8.8s-.36.8-.8.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.15"
					y1="545.39"
					x2="803.68"
					y2="545.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.15"
					y1="544.42"
					x2="799.15"
					y2="545.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="795.95 544.44 795.95 545.39 799.06 545.39 799.06 544.44 795.95 544.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="799.06"
					y1="544.44"
					x2="795.95"
					y2="544.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.06"
					y1="545.39"
					x2="799.06"
					y2="544.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.95"
					y1="545.39"
					x2="799.06"
					y2="545.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.95"
					y1="544.44"
					x2="795.95"
					y2="545.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="795.95 547.95 799.06 547.95 799.06 546.99 795.95 546.99 795.95 547.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="795.95"
					y1="546.99"
					x2="795.95"
					y2="547.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.06"
					y1="546.99"
					x2="795.95"
					y2="546.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="799.06"
					y1="547.95"
					x2="799.06"
					y2="546.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="795.95"
					y1="547.95"
					x2="799.06"
					y2="547.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.98"
					y1="618.7"
					x2="440.98"
					y2="602.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.98"
					y1="602.88"
					x2="398.05"
					y2="602.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.01"
					y1="618.7"
					x2="389.02"
					y2="618.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.02"
					y1="659.36"
					x2="450.01"
					y2="659.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.01"
					y1="659.36"
					x2="450.01"
					y2="598.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="389.02"
					y1="598.36"
					x2="389.02"
					y2="659.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.01"
					y1="599.49"
					x2="389.02"
					y2="599.49"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.05"
					y1="618.7"
					x2="398.05"
					y2="602.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.01"
					y1="598.36"
					x2="389.02"
					y2="598.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="747.58"
					y1="675.58"
					x2="743.11"
					y2="675.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.11"
					y1="675.58"
					x2="743.11"
					y2="677.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.11"
					y1="677.84"
					x2="747.58"
					y2="677.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="749.61"
					x2="758.62"
					y2="747.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="744.54"
					x2="758.62"
					y2="739.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="735.86"
					x2="758.62"
					y2="730.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="727.19"
					x2="758.62"
					y2="721.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="718.51"
					x2="758.62"
					y2="713.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="709.83"
					x2="758.62"
					y2="704.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="701.16"
					x2="758.62"
					y2="695.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="692.48"
					x2="758.62"
					y2="687.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="683.81"
					x2="758.62"
					y2="678.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="675.13"
					x2="758.62"
					y2="673.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="455.03"
					x2="785.73"
					y2="458.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="461.7"
					x2="785.73"
					y2="467.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="470.37"
					x2="785.73"
					y2="475.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="479.05"
					x2="785.73"
					y2="484.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="487.72"
					x2="785.73"
					y2="493.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="496.4"
					x2="785.73"
					y2="501.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="505.07"
					x2="785.73"
					y2="510.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="513.75"
					x2="785.73"
					y2="519.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="522.42"
					x2="785.73"
					y2="527.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="531.1"
					x2="785.73"
					y2="536.52"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="539.78"
					x2="785.73"
					y2="545.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="548.45"
					x2="785.73"
					y2="553.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="557.13"
					x2="785.73"
					y2="562.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="565.8"
					x2="785.73"
					y2="571.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="574.47"
					x2="785.73"
					y2="579.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="583.15"
					x2="785.73"
					y2="588.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="591.82"
					x2="785.73"
					y2="597.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="600.5"
					x2="785.73"
					y2="605.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="609.17"
					x2="785.73"
					y2="614.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="617.85"
					x2="785.73"
					y2="623.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="626.53"
					x2="785.73"
					y2="631.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="635.2"
					x2="785.73"
					y2="640.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="643.88"
					x2="785.73"
					y2="649.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="652.55"
					x2="785.73"
					y2="657.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="661.23"
					x2="785.73"
					y2="666.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="785.73"
					y1="669.9"
					x2="785.73"
					y2="673.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="455.03"
					x2="758.62"
					y2="580.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="455.03"
					x2="812.84"
					y2="455.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="670.66"
					y1="68.07"
					x2="492.89"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="492.89"
					y1="50"
					x2="670.66"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="365.41"
					y1="68.07"
					x2="216.1"
					y2="68.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="216.1"
					y1="50"
					x2="365.41"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="758.62"
					y1="647.88"
					x2="758.62"
					y2="673.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.98"
					y1="652.59"
					x2="398.05"
					y2="652.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.05"
					y1="652.59"
					x2="398.05"
					y2="623.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="398.05"
					y1="623.21"
					x2="440.98"
					y2="623.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="440.98"
					y1="623.21"
					x2="440.98"
					y2="652.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="852.6 655.24 852.6 948.87 825.94 948.87 825.94 930.8 834.52 930.8 834.52 749.61 831.21 749.61 831.21 673.32 812.84 673.32 812.84 382.2 736.1 382.2 736.1 68.07 670.66 68.07 670.66 50 754.17 50 754.17 364.12 830.91 364.12 830.91 655.24 852.6 655.24"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.2"
				/>
				<polygon
					points="492.9 50 492.9 68.07 481.18 68.07 481.18 454.23 455.41 454.23 455.41 442.93 469.88 442.93 469.88 141.45 416.68 141.45 416.68 68.07 365.41 68.07 365.41 50 492.9 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.2"
				/>
				<polygon
					points="740.1 930.8 740.1 948.87 664.17 948.87 664.17 683.71 147.4 683.71 147.4 50 216.1 50 216.1 68.07 165.48 68.07 165.48 379.28 188.02 379.28 188.02 390.58 165.48 390.58 165.48 442.93 332.26 442.93 332.26 390.58 317.92 390.58 317.92 379.28 343.56 379.28 343.56 442.93 383.12 442.93 383.12 454.23 351.04 454.23 351.04 467.72 339.75 467.72 339.75 454.23 188.8 454.23 188.8 593.36 208.45 593.36 208.45 665.64 339.75 665.64 339.75 540.01 351.04 540.01 351.04 581.5 385.63 581.5 385.63 592.8 380.86 592.8 380.86 665.64 458.17 665.64 458.17 592.8 453.4 592.8 453.4 581.5 498.13 581.5 498.13 592.8 469.46 592.8 469.46 665.64 670.95 665.64 670.95 592.8 643.84 592.8 643.84 581.5 682.24 581.5 682.24 930.8 740.1 930.8"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.2"
				/>
			</g>
			<g id="text">
				<path d="m786.08,717.74h-1.47l-1.76-2.96c-.16-.27-.32-.51-.47-.7-.15-.2-.31-.36-.47-.48-.16-.12-.33-.21-.51-.26-.18-.06-.39-.09-.62-.09h-1.02v4.49h-1.24v-10.55h3.15c.46,0,.88.06,1.27.18.39.11.73.29,1.01.52.29.24.51.53.68.88.16.35.24.76.24,1.23,0,.37-.06.71-.17,1.01-.11.3-.26.58-.47.82-.2.24-.45.45-.74.62-.28.17-.61.3-.96.39v.03c.18.08.33.17.46.27.13.1.26.22.38.35.12.14.23.29.35.47.12.17.25.37.39.6l1.98,3.17Zm-6.32-9.43v3.82h1.68c.31,0,.59-.05.85-.14.26-.09.49-.23.68-.4.19-.18.34-.39.45-.64.11-.25.16-.54.16-.85,0-.56-.18-1-.55-1.32-.36-.32-.89-.48-1.58-.48h-1.69Zm13.53,5.96h-5.32c.02.84.25,1.49.68,1.94.43.46,1.02.68,1.78.68.85,0,1.63-.28,2.34-.84v1.13c-.66.48-1.54.72-2.63.72s-1.9-.34-2.51-1.02c-.61-.69-.91-1.65-.91-2.89,0-1.17.33-2.13.99-2.86.67-.74,1.49-1.11,2.48-1.11s1.75.32,2.29.96c.54.64.81,1.52.81,2.65v.63Zm-1.24-1.02c0-.7-.17-1.24-.51-1.63-.33-.39-.79-.58-1.38-.58s-1.05.2-1.45.61c-.4.41-.64.94-.74,1.6h4.07Zm6.65-5.6c-.24-.13-.5-.2-.8-.2-.84,0-1.26.53-1.26,1.6v1.16h1.76v1.03h-1.76v6.5h-1.2v-6.5h-1.29v-1.03h1.29v-1.22c0-.79.23-1.41.68-1.87.46-.46,1.02-.69,1.71-.69.37,0,.66.04.88.13v1.09Z" />
				<path d="m799.98,717.9c-.23,0-.42-.08-.58-.24-.16-.16-.24-.36-.24-.58s.08-.42.24-.58c.16-.17.36-.25.58-.25s.43.08.59.25c.16.16.24.36.24.58s-.08.42-.24.58c-.16.16-.36.24-.59.24Z" />
				<path d="m786.85,488.29v-10.47h3.61c.81,0,1.44.05,1.86.15.6.14,1.11.39,1.54.75.55.47.96,1.06,1.24,1.79.28.72.41,1.55.41,2.49,0,.8-.09,1.5-.28,2.11s-.42,1.12-.71,1.53c-.29.4-.61.72-.96.95-.34.23-.76.4-1.25.52-.49.12-1.05.18-1.68.18h-3.78Zm1.39-1.24h2.24c.69,0,1.23-.06,1.62-.19.4-.13.71-.31.94-.54.33-.33.58-.77.76-1.32.19-.56.28-1.23.28-2.02,0-1.1-.18-1.94-.54-2.52-.36-.59-.79-.99-1.31-1.19-.37-.14-.97-.21-1.79-.21h-2.2v8Zm11.02,1.24l-2.78-10.47h1.42l1.59,6.87c.17.72.32,1.43.44,2.14.27-1.12.42-1.76.47-1.94l1.99-7.07h1.67l1.5,5.3c.38,1.31.65,2.55.81,3.71.13-.66.31-1.42.52-2.28l1.64-6.73h1.39l-2.87,10.47h-1.34l-2.21-7.98c-.19-.67-.3-1.08-.33-1.23-.11.48-.21.89-.31,1.23l-2.22,7.98h-1.41Z" />
				<path d="m516.92,327.17h-8.5v-16.38h1.92v14.64h6.58v1.74Zm3.22-14.66c-.33,0-.62-.11-.86-.34s-.35-.52-.35-.87.12-.64.35-.87c.24-.24.52-.35.86-.35s.63.12.87.35c.24.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.35-.87.35Zm.91,14.66h-1.87v-11.7h1.87v11.7Zm12.97-11.7l-4.66,11.7h-1.84l-4.43-11.7h2.06l2.97,8.5c.22.62.36,1.17.41,1.63h.05c.08-.59.2-1.12.37-1.59l3.11-8.54h1.98Zm2.96-2.97c-.34,0-.62-.11-.86-.34s-.35-.52-.35-.87.12-.64.35-.87c.24-.24.52-.35.86-.35s.63.12.87.35c.24.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.35-.87.35Zm.91,14.66h-1.87v-11.7h1.87v11.7Zm13.49,0h-1.87v-6.67c0-2.48-.91-3.72-2.72-3.72-.94,0-1.71.35-2.33,1.06-.61.7-.91,1.59-.91,2.66v6.67h-1.87v-11.7h1.87v1.94h.05c.88-1.48,2.16-2.22,3.84-2.22,1.28,0,2.26.42,2.94,1.24.68.82,1.02,2.01,1.02,3.57v7.15Zm13.5-.94c0,4.29-2.06,6.44-6.17,6.44-1.45,0-2.71-.27-3.79-.82v-1.87c1.32.73,2.57,1.1,3.77,1.1,2.88,0,4.32-1.53,4.32-4.59v-1.28h-.05c-.89,1.49-2.23,2.24-4.02,2.24-1.45,0-2.63-.52-3.52-1.55-.88-1.04-1.32-2.44-1.32-4.19,0-1.99.48-3.57,1.43-4.74.96-1.17,2.27-1.76,3.93-1.76s2.74.63,3.51,1.9h.05v-1.62h1.87v10.76Zm-1.87-4.35v-1.72c0-.93-.32-1.72-.95-2.39-.62-.66-1.4-.99-2.34-.99-1.16,0-2.06.42-2.72,1.27-.65.84-.98,2.01-.98,3.53,0,1.3.31,2.35.94,3.13.63.78,1.47,1.16,2.5,1.16s1.9-.37,2.56-1.12c.66-.75.99-1.7.99-2.87Z" />
				<polygon points="576.06 310.79 568.2 329.89 566.45 329.89 574.29 310.79 576.06 310.79" />
				<path d="m577.96,327.17v-16.38h4.52c5.77,0,8.66,2.66,8.66,7.98,0,2.53-.8,4.56-2.41,6.1-1.6,1.53-3.74,2.3-6.43,2.3h-4.34Zm1.92-14.64v12.91h2.44c2.15,0,3.82-.57,5.01-1.72s1.79-2.78,1.79-4.89c0-4.2-2.23-6.29-6.69-6.29h-2.56Zm15.11-.02c-.33,0-.62-.11-.86-.34-.24-.23-.35-.52-.35-.87s.12-.64.35-.87c.24-.24.52-.35.86-.35s.63.12.87.35c.24.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.35-.87.35Zm.91,14.66h-1.87v-11.7h1.87v11.7Zm13.42,0h-1.87v-6.67c0-2.48-.91-3.72-2.72-3.72-.94,0-1.71.35-2.33,1.06-.61.7-.91,1.59-.91,2.66v6.67h-1.87v-11.7h1.87v1.94h.05c.88-1.48,2.16-2.22,3.84-2.22,1.28,0,2.26.41,2.94,1.24.68.82,1.02,2.01,1.02,3.57v7.15Zm4.42-14.66c-.34,0-.62-.11-.86-.34-.24-.23-.35-.52-.35-.87s.12-.64.35-.87c.24-.24.52-.35.86-.35s.63.12.87.35c.24.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.35-.87.35Zm.91,14.66h-1.87v-11.7h1.87v11.7Zm13.42,0h-1.87v-6.67c0-2.48-.91-3.72-2.72-3.72-.94,0-1.71.35-2.33,1.06-.61.7-.91,1.59-.91,2.66v6.67h-1.87v-11.7h1.87v1.94h.05c.88-1.48,2.16-2.22,3.84-2.22,1.28,0,2.26.41,2.94,1.24.68.82,1.02,2.01,1.02,3.57v7.15Zm13.44-.94c0,4.29-2.06,6.44-6.17,6.44-1.45,0-2.71-.27-3.79-.82v-1.87c1.32.73,2.57,1.1,3.77,1.1,2.88,0,4.32-1.53,4.32-4.59v-1.28h-.05c-.89,1.49-2.23,2.24-4.02,2.24-1.45,0-2.63-.52-3.52-1.55-.88-1.04-1.32-2.44-1.32-4.19,0-1.99.48-3.57,1.43-4.74.96-1.17,2.27-1.76,3.93-1.76s2.74.63,3.51,1.9h.05v-1.62h1.87v10.76Zm-1.87-4.35v-1.72c0-.93-.32-1.72-.95-2.39-.62-.66-1.4-.99-2.34-.99-1.16,0-2.06.42-2.72,1.27-.65.84-.98,2.01-.98,3.53,0,1.3.31,2.35.94,3.13.63.78,1.47,1.16,2.5,1.16s1.9-.37,2.56-1.12c.66-.75.99-1.7.99-2.87Z" />
				<path d="m663.93,327.17h-2.28l-2.74-4.59c-.25-.43-.49-.79-.73-1.09-.24-.3-.48-.55-.73-.74-.24-.19-.51-.33-.8-.41-.28-.09-.6-.14-.96-.14h-1.58v6.97h-1.92v-16.38h4.89c.72,0,1.37.09,1.98.27.61.18,1.13.45,1.58.81.45.37.8.82,1.05,1.37.25.54.38,1.18.38,1.91,0,.57-.09,1.1-.26,1.58-.17.47-.41.89-.73,1.27-.31.37-.69.69-1.14.96-.44.26-.94.46-1.5.61v.05c.27.12.51.26.71.42.21.15.4.34.58.55.18.21.36.46.54.73.18.27.38.58.61.94l3.07,4.92Zm-9.82-14.64v5.94h2.6c.48,0,.92-.07,1.32-.22.41-.14.77-.35,1.06-.62.3-.27.53-.61.7-.99.17-.4.25-.84.25-1.32,0-.88-.29-1.56-.86-2.04-.56-.49-1.38-.74-2.46-.74h-2.63Zm16.63,14.92c-1.73,0-3.11-.54-4.15-1.63-1.03-1.1-1.54-2.55-1.54-4.35,0-1.96.54-3.5,1.61-4.6,1.07-1.1,2.52-1.66,4.35-1.66s3.1.54,4.08,1.61c.98,1.07,1.47,2.56,1.47,4.47s-.53,3.36-1.59,4.49c-1.05,1.12-2.46,1.68-4.24,1.68Zm.14-10.67c-1.2,0-2.15.41-2.86,1.23-.7.81-1.05,1.94-1.05,3.38s.35,2.48,1.06,3.28,1.66,1.2,2.84,1.2,2.14-.39,2.79-1.18c.65-.78.98-1.9.98-3.35s-.33-2.59-.98-3.38c-.65-.79-1.58-1.19-2.79-1.19Zm13.5,10.67c-1.73,0-3.11-.54-4.15-1.63-1.03-1.1-1.54-2.55-1.54-4.35,0-1.96.54-3.5,1.61-4.6,1.07-1.1,2.52-1.66,4.35-1.66s3.1.54,4.08,1.61c.98,1.07,1.47,2.56,1.47,4.47s-.53,3.36-1.59,4.49c-1.05,1.12-2.46,1.68-4.24,1.68Zm.14-10.67c-1.2,0-2.15.41-2.86,1.23-.7.81-1.05,1.94-1.05,3.38s.35,2.48,1.06,3.28c.71.8,1.66,1.2,2.84,1.2s2.14-.39,2.79-1.18c.65-.78.98-1.9.98-3.35s-.33-2.59-.98-3.38c-.65-.79-1.58-1.19-2.79-1.19Zm25.22,10.39h-1.87v-6.72c0-1.29-.2-2.23-.61-2.81-.4-.58-1.07-.87-2.01-.87-.8,0-1.48.37-2.04,1.1-.56.73-.83,1.61-.83,2.63v6.67h-1.87v-6.94c0-2.3-.89-3.45-2.66-3.45-.82,0-1.5.35-2.03,1.04-.53.69-.8,1.58-.8,2.68v6.67h-1.87v-11.7h1.87v1.85h.05c.83-1.42,2.04-2.12,3.63-2.12.8,0,1.5.22,2.09.67.59.44,1,1.02,1.22,1.75.87-1.61,2.16-2.42,3.88-2.42,2.57,0,3.86,1.59,3.86,4.76v7.21Z" />
				<path d="m574.9,344.78c0,1.09-.11,2.06-.32,2.91-.22.85-.53,1.57-.95,2.16-.42.59-.92,1.04-1.52,1.35-.6.3-1.28.46-2.04.46s-1.48-.14-2.08-.42v-1.3c.66.37,1.36.56,2.11.56.54,0,1.02-.11,1.44-.33.43-.22.79-.54,1.08-.96.29-.43.52-.95.67-1.57.16-.62.23-1.33.23-2.13h-.03c-.51,1.02-1.39,1.54-2.66,1.54-.51,0-.98-.09-1.4-.27-.43-.18-.79-.44-1.1-.76-.31-.33-.55-.73-.72-1.18-.17-.45-.26-.95-.26-1.5,0-.59.09-1.12.28-1.61.19-.49.46-.91.8-1.25.34-.35.75-.63,1.21-.82.47-.19.98-.29,1.54-.29.6,0,1.13.12,1.59.37.47.24.86.59,1.17,1.05.32.46.56,1.03.72,1.7.17.68.25,1.45.25,2.32Zm-1.47-1.22c0-.46-.06-.88-.18-1.25-.12-.38-.28-.7-.49-.96-.21-.27-.46-.48-.76-.62-.29-.15-.6-.22-.95-.22s-.63.07-.91.2c-.28.13-.53.31-.74.55-.2.23-.37.51-.49.84-.12.32-.17.67-.17,1.05,0,.42.06.8.17,1.13.12.33.28.61.49.85.21.23.46.4.76.52.3.12.63.18.99.18.32,0,.61-.06.89-.17.28-.12.53-.28.73-.48.21-.2.37-.44.49-.71.12-.28.18-.57.18-.89Z" />
				<rect x="577.11" y="339.54" width="1.2" height="3.71" />
				<path d="m588.1,347.67c0,.58-.09,1.12-.28,1.6s-.45.91-.78,1.26c-.33.35-.73.63-1.19.83-.46.19-.96.29-1.49.29-.6,0-1.13-.12-1.61-.37-.47-.25-.87-.61-1.2-1.07-.33-.47-.58-1.04-.75-1.72-.17-.68-.26-1.44-.26-2.28,0-1.04.11-1.97.34-2.81.23-.85.56-1.57.98-2.17.43-.6.94-1.07,1.54-1.39.6-.33,1.26-.49,2-.49.82,0,1.48.11,1.98.34v1.29c-.61-.32-1.26-.47-1.94-.47-.53,0-1.01.12-1.44.36s-.79.58-1.1,1.01c-.3.43-.54.95-.71,1.57-.16.61-.24,1.3-.24,2.05h.03c.55-.99,1.45-1.49,2.72-1.49.52,0,.99.09,1.4.27.42.18.78.43,1.07.76.3.32.53.71.69,1.15.16.45.24.95.24,1.49Zm-1.39.17c0-.42-.05-.79-.16-1.12s-.26-.61-.46-.85c-.19-.23-.43-.41-.72-.53-.29-.13-.61-.19-.98-.19-.34,0-.65.06-.94.19-.29.13-.54.3-.75.52-.21.22-.38.47-.5.76-.12.29-.17.6-.17.92,0,.41.06.79.17,1.15.12.35.28.66.49.93.21.27.46.48.75.63.29.15.62.22.97.22s.66-.06.94-.19c.28-.13.52-.32.72-.55.2-.23.35-.51.46-.83.11-.33.17-.69.17-1.08Z" />
				<path d="m591.35,339.54v3.71h-1.2v-3.71h1.2Zm2.76,0v3.71h-1.2v-3.71h1.2Z" />
				<path d="m607.72,342.94l-2.86,4.3,2.81,4.2h-1.59l-1.67-2.76c-.11-.17-.23-.39-.37-.65h-.03s-.16.27-.39.65l-1.7,2.76h-1.57l2.9-4.17-2.77-4.33h1.59l1.64,2.91c.12.22.24.44.36.66h.03l2.13-3.57h1.5Z" />
				<path d="m618.62,351.45h-1.36v-10.29c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.51.26-.8.37-.28.12-.55.21-.81.27v-1.38c.3-.08.61-.19.95-.33.34-.14.67-.3.99-.47.33-.18.63-.36.92-.55.29-.19.54-.38.75-.56h.51v12.17Zm11.51-6.67c0,1.09-.11,2.06-.32,2.91-.22.85-.53,1.57-.95,2.16-.42.59-.92,1.04-1.52,1.35-.6.3-1.28.46-2.04.46s-1.48-.14-2.08-.42v-1.3c.66.37,1.36.56,2.11.56.54,0,1.02-.11,1.44-.33.43-.22.79-.54,1.08-.96.29-.43.52-.95.67-1.57.15-.62.23-1.33.23-2.13h-.03c-.51,1.02-1.39,1.54-2.66,1.54-.51,0-.98-.09-1.4-.27-.43-.18-.79-.44-1.1-.76-.31-.33-.55-.73-.72-1.18s-.26-.95-.26-1.5c0-.59.09-1.12.28-1.61.19-.49.46-.91.8-1.25.34-.35.75-.63,1.21-.82.47-.19.98-.29,1.54-.29.6,0,1.13.12,1.59.37.47.24.86.59,1.17,1.05.32.46.56,1.03.72,1.7s.25,1.45.25,2.32Zm-1.47-1.22c0-.46-.06-.88-.18-1.25-.12-.38-.28-.7-.49-.96-.21-.27-.46-.48-.76-.62-.29-.15-.6-.22-.95-.22s-.63.07-.91.2c-.28.13-.53.31-.74.55-.2.23-.37.51-.49.84-.12.32-.17.67-.17,1.05,0,.42.06.8.17,1.13.12.33.28.61.49.85.21.23.46.4.76.52.3.12.63.18.99.18.32,0,.61-.06.89-.17.28-.12.53-.28.73-.48.21-.2.37-.44.49-.71.12-.28.18-.57.18-.89Z" />
				<rect x="632.33" y="339.54" width="1.2" height="3.71" />
				<path d="m643.31,345.44c0,1-.09,1.88-.27,2.65-.18.77-.44,1.42-.78,1.95-.34.53-.76.93-1.25,1.2-.49.27-1.05.41-1.69.41-.6,0-1.13-.13-1.6-.39-.47-.27-.86-.65-1.18-1.15s-.56-1.12-.73-1.85c-.17-.74-.25-1.58-.25-2.52,0-1.04.09-1.96.26-2.76.18-.8.43-1.46.77-2,.34-.54.76-.95,1.25-1.22.5-.28,1.08-.42,1.73-.42,2.5,0,3.74,2.03,3.74,6.1Zm-1.39.13c0-3.39-.81-5.08-2.42-5.08-1.7,0-2.55,1.72-2.55,5.17,0,3.22.83,4.82,2.5,4.82s2.47-1.64,2.47-4.92Z" />
				<path d="m646.58,339.54v3.71h-1.2v-3.71h1.2Zm2.76,0v3.71h-1.2v-3.71h1.2Z" />
				<path d="m272.35,222.08v-16.38h4.66c1.42,0,2.54.35,3.37,1.04.83.69,1.24,1.6,1.24,2.71,0,.93-.25,1.74-.75,2.42-.5.69-1.2,1.17-2.08,1.46v.05c1.1.13,1.99.55,2.65,1.26.66.7.99,1.61.99,2.74,0,1.4-.5,2.54-1.51,3.4s-2.27,1.3-3.8,1.3h-4.77Zm1.92-14.64v5.29h1.96c1.05,0,1.88-.25,2.48-.75.6-.51.9-1.23.9-2.15,0-1.59-1.05-2.39-3.14-2.39h-2.2Zm0,7.01v5.89h2.6c1.13,0,2-.27,2.62-.8.62-.53.94-1.26.94-2.19,0-1.93-1.32-2.9-3.95-2.9h-2.2Zm20.61,2.25h-8.26c.03,1.3.38,2.31,1.05,3.02.67.71,1.59,1.06,2.76,1.06,1.32,0,2.53-.43,3.63-1.3v1.76c-1.03.75-2.39,1.12-4.08,1.12s-2.95-.53-3.89-1.59c-.94-1.07-1.42-2.56-1.42-4.49,0-1.82.51-3.3,1.54-4.44,1.04-1.15,2.32-1.72,3.85-1.72s2.71.49,3.55,1.48c.84.99,1.26,2.36,1.26,4.12v.98Zm-1.92-1.59c0-1.08-.27-1.92-.79-2.52-.51-.6-1.22-.9-2.14-.9s-1.63.32-2.25.95c-.62.63-1,1.46-1.14,2.48h6.32Zm14.71,6.97h-1.87v-1.99h-.05c-.87,1.51-2.21,2.26-4.02,2.26-1.47,0-2.65-.52-3.53-1.56-.88-1.05-1.31-2.48-1.31-4.28,0-1.93.49-3.48,1.46-4.65.97-1.16,2.27-1.75,3.89-1.75s2.78.63,3.51,1.9h.05v-7.24h1.87v17.31Zm-1.87-5.29v-1.72c0-.94-.31-1.74-.94-2.4-.62-.65-1.42-.98-2.38-.98-1.14,0-2.04.42-2.7,1.26-.65.84-.98,1.99-.98,3.47,0,1.35.31,2.41.94,3.2.63.78,1.48,1.16,2.54,1.16s1.89-.38,2.54-1.13c.65-.75.98-1.71.98-2.86Zm11.75-4.51c-.33-.25-.8-.38-1.42-.38-.8,0-1.47.38-2.01,1.13-.53.75-.8,1.78-.8,3.08v5.96h-1.87v-11.7h1.87v2.41h.05c.27-.82.67-1.46,1.22-1.92.55-.46,1.16-.7,1.84-.7.49,0,.86.05,1.12.16v1.94Zm6.91,10.07c-1.73,0-3.11-.54-4.15-1.63-1.03-1.1-1.54-2.55-1.54-4.35,0-1.96.54-3.5,1.61-4.6,1.07-1.1,2.52-1.66,4.35-1.66s3.1.54,4.08,1.61c.98,1.07,1.47,2.56,1.47,4.47s-.53,3.36-1.59,4.49c-1.05,1.12-2.46,1.68-4.24,1.68Zm.14-10.67c-1.2,0-2.15.41-2.86,1.23-.7.81-1.05,1.94-1.05,3.38s.35,2.48,1.06,3.28c.71.8,1.66,1.2,2.84,1.2s2.14-.39,2.79-1.18c.65-.78.98-1.9.98-3.35s-.33-2.59-.98-3.38c-.65-.79-1.58-1.19-2.79-1.19Zm13.55,10.67c-1.73,0-3.11-.54-4.15-1.63-1.03-1.1-1.54-2.55-1.54-4.35,0-1.96.54-3.5,1.61-4.6,1.07-1.1,2.52-1.66,4.35-1.66s3.1.54,4.08,1.61c.98,1.07,1.47,2.56,1.47,4.47s-.53,3.36-1.59,4.49c-1.05,1.12-2.46,1.68-4.24,1.68Zm.14-10.67c-1.2,0-2.15.41-2.86,1.23-.7.81-1.05,1.94-1.05,3.38s.35,2.48,1.06,3.28c.71.8,1.66,1.2,2.84,1.2s2.14-.39,2.79-1.18c.65-.78.98-1.9.98-3.35s-.33-2.59-.98-3.38c-.65-.79-1.58-1.19-2.79-1.19Zm25.27,10.39h-1.87v-6.72c0-1.29-.2-2.23-.61-2.81-.4-.58-1.07-.87-2.01-.87-.8,0-1.48.37-2.04,1.1-.56.73-.83,1.61-.83,2.63v6.67h-1.87v-6.94c0-2.3-.89-3.45-2.66-3.45-.82,0-1.5.35-2.03,1.04-.53.69-.8,1.58-.8,2.68v6.67h-1.87v-11.7h1.87v1.85h.05c.83-1.42,2.04-2.12,3.63-2.12.8,0,1.5.22,2.09.67.59.44,1,1.02,1.22,1.75.87-1.61,2.16-2.42,3.88-2.42,2.57,0,3.86,1.59,3.86,4.76v7.21Z" />
				<path d="m277.03,246.36h-1.36v-10.29c-.11.11-.26.23-.46.37-.2.13-.43.27-.68.4-.25.13-.51.26-.8.37-.28.12-.55.21-.81.27v-1.38c.3-.08.61-.19.95-.33.34-.14.67-.3.99-.47.33-.18.63-.36.92-.55.29-.19.54-.38.75-.56h.51v12.17Zm9.19,0h-1.36v-10.29c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.51.26-.8.37-.28.12-.55.21-.81.27v-1.38c.3-.08.61-.19.95-.33.34-.14.67-.3.99-.47.33-.18.63-.36.92-.55.29-.19.54-.38.75-.56h.51v12.17Z" />
				<rect x="290.74" y="234.45" width="1.2" height="3.71" />
				<path d="m299.65,237.57c0-.37-.06-.68-.17-.95-.11-.27-.27-.5-.47-.67-.19-.18-.42-.32-.69-.41-.27-.09-.55-.13-.86-.13-.27,0-.53.04-.78.11s-.5.17-.75.3c-.24.13-.47.28-.7.46-.22.18-.43.37-.62.59v-1.46c.38-.37.81-.65,1.28-.85.48-.2,1.05-.3,1.74-.3.49,0,.94.07,1.35.22.42.14.77.34,1.08.61.3.27.54.61.71,1,.18.4.27.86.27,1.37,0,.47-.06.9-.17,1.28-.11.38-.27.74-.49,1.08-.22.34-.49.66-.82.97s-.72.63-1.17.95c-.56.4-1.02.74-1.39,1.02-.36.28-.65.55-.86.8-.21.24-.36.49-.45.74-.08.24-.12.53-.12.85h5.93v1.22h-7.35v-.59c0-.51.06-.96.17-1.35.11-.39.29-.76.55-1.1.25-.35.59-.7,1-1.05.42-.35.92-.74,1.52-1.18.43-.31.79-.61,1.08-.89.29-.28.53-.56.71-.85.18-.28.3-.57.37-.86.08-.29.12-.6.12-.93Z" />
				<path d="m304.99,234.45v3.71h-1.2v-3.71h1.2Zm2.76,0v3.71h-1.2v-3.71h1.2Z" />
				<path d="m321.36,237.86l-2.86,4.3,2.81,4.2h-1.59l-1.67-2.76c-.11-.17-.23-.39-.37-.65h-.03s-.16.27-.39.65l-1.7,2.76h-1.57l2.9-4.17-2.77-4.33h1.59l1.64,2.91c.12.22.24.44.36.66h.03l2.13-3.57h1.5Z" />
				<path d="m332.26,246.36h-1.36v-10.29c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.51.26-.8.37-.28.12-.55.21-.81.27v-1.38c.3-.08.61-.19.95-.33.34-.14.67-.3.99-.47.33-.18.63-.36.92-.55.29-.19.54-.38.75-.56h.51v12.17Zm9.19,0h-1.36v-10.29c-.11.11-.26.23-.47.37-.2.13-.43.27-.68.4-.25.13-.51.26-.8.37-.28.12-.55.21-.81.27v-1.38c.3-.08.61-.19.95-.33.34-.14.67-.3.99-.47.33-.18.63-.36.92-.55.29-.19.54-.38.75-.56h.51v12.17Z" />
				<rect x="345.97" y="234.45" width="1.2" height="3.71" />
				<path d="m356.96,242.58c0,.58-.09,1.12-.28,1.6-.19.49-.45.91-.78,1.26-.33.35-.73.63-1.19.83-.46.19-.96.29-1.49.29-.6,0-1.13-.12-1.61-.37-.47-.25-.87-.61-1.2-1.07-.33-.47-.58-1.04-.75-1.72-.17-.68-.26-1.44-.26-2.28,0-1.04.11-1.97.34-2.81.23-.85.56-1.57.98-2.17.43-.6.94-1.07,1.54-1.39s1.26-.49,2-.49c.82,0,1.48.11,1.98.34v1.29c-.61-.32-1.26-.47-1.94-.47-.53,0-1.01.12-1.44.36-.43.24-.79.58-1.1,1.01-.3.43-.54.95-.71,1.57-.16.61-.24,1.3-.24,2.05h.03c.55-.99,1.45-1.49,2.72-1.49.52,0,.99.09,1.4.27.42.18.78.43,1.07.76.3.32.53.71.69,1.15.16.45.24.95.24,1.49h0Zm-1.39.17c0-.42-.05-.79-.16-1.12-.11-.33-.26-.61-.46-.85-.19-.23-.43-.41-.72-.53-.29-.13-.61-.19-.98-.19-.34,0-.65.06-.94.19-.29.13-.54.3-.75.52-.21.22-.38.47-.5.76-.12.29-.17.6-.17.92,0,.41.06.79.17,1.15.12.35.28.66.49.93.21.27.46.48.75.63.29.15.62.22.97.22s.66-.06.94-.19c.28-.13.52-.32.72-.55.2-.23.35-.51.47-.83.11-.33.17-.69.17-1.08Z" />
				<path d="m360.21,234.45v3.71h-1.2v-3.71h1.2Zm2.76,0v3.71h-1.2v-3.71h1.2Z" />
				<path d="m695.7,575.65h-2.67l-6.33-7.49c-.24-.28-.38-.47-.43-.57h-.05v8.06h-1.92v-16.38h1.92v7.7h.05c.11-.17.25-.35.43-.56l6.12-7.14h2.39l-7.02,7.86,7.52,8.52Zm2.86-14.66c-.33,0-.62-.11-.86-.34-.24-.23-.35-.52-.35-.87s.12-.64.35-.87c.24-.24.52-.35.86-.35s.63.12.87.35c.24.23.37.52.37.87s-.12.62-.37.86c-.24.24-.53.35-.87.35Zm.91,14.66h-1.87v-11.7h1.87v11.7Zm9.2-.11c-.44.24-1.02.37-1.75.37-2.05,0-3.07-1.14-3.07-3.43v-6.92h-2.01v-1.6h2.01v-2.86l1.87-.61v3.46h2.95v1.6h-2.95v6.59c0,.78.13,1.34.4,1.68.27.34.71.5,1.32.5.47,0,.88-.13,1.22-.39v1.6Zm10.46-.42c-.9.54-1.96.81-3.2.81-1.67,0-3.02-.54-4.04-1.62-1.02-1.09-1.53-2.5-1.53-4.23,0-1.93.55-3.47,1.66-4.64,1.1-1.17,2.58-1.76,4.42-1.76,1.03,0,1.93.19,2.72.57v1.92c-.87-.61-1.8-.91-2.79-.91-1.2,0-2.18.43-2.95,1.29-.76.85-1.14,1.98-1.14,3.37s.36,2.45,1.07,3.24c.72.79,1.69,1.19,2.9,1.19,1.02,0,1.98-.34,2.88-1.02v1.78Zm12.53.54h-1.87v-6.74c0-2.44-.91-3.65-2.72-3.65-.91,0-1.68.35-2.31,1.06-.62.7-.94,1.6-.94,2.71v6.62h-1.87v-17.31h1.87v7.56h.05c.9-1.48,2.18-2.22,3.84-2.22,2.63,0,3.95,1.59,3.95,4.76v7.21Zm12.91-5.38h-8.26c.03,1.3.38,2.31,1.05,3.02.67.71,1.59,1.06,2.76,1.06,1.32,0,2.53-.43,3.63-1.3v1.76c-1.03.75-2.39,1.12-4.08,1.12s-2.95-.53-3.89-1.59c-.94-1.07-1.42-2.56-1.42-4.49,0-1.82.51-3.3,1.54-4.44,1.04-1.15,2.32-1.72,3.85-1.72s2.71.49,3.55,1.48c.84.99,1.26,2.36,1.26,4.12v.98Zm-1.92-1.59c0-1.08-.27-1.92-.79-2.52-.51-.6-1.22-.9-2.14-.9s-1.63.32-2.25.95c-.62.63-1,1.46-1.14,2.48h6.32Zm14.44,6.97h-1.87v-6.67c0-2.48-.91-3.72-2.72-3.72-.94,0-1.71.35-2.33,1.06-.61.7-.91,1.59-.91,2.66v6.67h-1.87v-11.7h1.87v1.94h.05c.88-1.48,2.16-2.22,3.84-2.22,1.28,0,2.26.41,2.94,1.24.68.82,1.02,2.01,1.02,3.57v7.15Z" />
				<path d="m742.94,849.95h-8.68v-16.38h8.31v1.74h-6.4v5.45h5.92v1.72h-5.92v5.73h6.76v1.74Zm12.63,0h-1.87v-6.67c0-2.48-.91-3.72-2.72-3.72-.94,0-1.71.35-2.33,1.06-.61.7-.91,1.59-.91,2.66v6.67h-1.87v-11.7h1.87v1.94h.05c.88-1.48,2.16-2.22,3.84-2.22,1.28,0,2.26.42,2.94,1.25.68.82,1.02,2.01,1.02,3.57v7.15Zm8.97-.11c-.44.24-1.02.37-1.75.37-2.05,0-3.07-1.14-3.07-3.43v-6.92h-2.01v-1.6h2.01v-2.86l1.87-.61v3.46h2.95v1.6h-2.95v6.59c0,.78.13,1.34.4,1.68.27.33.71.5,1.32.5.47,0,.88-.13,1.22-.39v1.6Zm8.62-9.69c-.33-.25-.8-.38-1.42-.38-.8,0-1.47.38-2.01,1.13-.53.75-.8,1.78-.8,3.08v5.96h-1.87v-11.7h1.87v2.41h.05c.27-.82.67-1.46,1.22-1.92.55-.46,1.16-.7,1.84-.7.49,0,.86.05,1.12.16v1.94Zm11.37-1.9l-5.38,13.57c-.96,2.42-2.31,3.63-4.04,3.63-.49,0-.89-.05-1.22-.15v-1.68c.4.14.77.21,1.11.21.94,0,1.65-.56,2.12-1.69l.94-2.22-4.57-11.67h2.08l3.16,9c.04.11.12.41.24.89h.07c.04-.18.11-.47.23-.87l3.32-9.02h1.94Z" />
				<path d="m265.77,558.62v-16.38h4.66c1.42,0,2.54.35,3.37,1.04.83.69,1.24,1.6,1.24,2.71,0,.93-.25,1.74-.75,2.42-.5.69-1.2,1.17-2.08,1.46v.05c1.1.13,1.99.55,2.65,1.26.66.7.99,1.61.99,2.74,0,1.4-.5,2.54-1.51,3.4-1.01.87-2.27,1.3-3.8,1.3h-4.77Zm1.92-7.63v5.89h2.6c1.13,0,2-.27,2.62-.8.62-.53.94-1.26.94-2.19,0-1.93-1.32-2.9-3.95-2.9h-2.2Zm0-7.01v5.29h1.96c1.05,0,1.88-.25,2.48-.75.6-.51.9-1.23.9-2.15,0-1.59-1.05-2.39-3.14-2.39h-2.2Zm19.6,14.64h-1.87v-1.83h-.05c-.81,1.4-2.01,2.1-3.6,2.1-1.16,0-2.08-.31-2.74-.93-.65-.62-.98-1.44-.98-2.46,0-2.19,1.29-3.46,3.86-3.81l3.51-.49c0-1.99-.8-2.98-2.41-2.98-1.41,0-2.68.48-3.81,1.44v-1.92c1.15-.73,2.47-1.1,3.97-1.1,2.75,0,4.12,1.45,4.12,4.36v7.61Zm-1.87-5.92l-2.82.39c-.87.12-1.52.34-1.96.65-.44.3-.66.85-.66,1.63,0,.57.2,1.04.61,1.4.41.36.96.54,1.63.54.93,0,1.69-.32,2.3-.97.61-.65.91-1.48.91-2.48v-1.16Zm10.83,5.8c-.44.24-1.02.37-1.75.37-2.05,0-3.07-1.14-3.07-3.43v-6.92h-2.01v-1.6h2.01v-2.86l1.87-.61v3.46h2.95v1.6h-2.95v6.59c0,.78.13,1.34.4,1.68.27.33.71.5,1.32.5.47,0,.88-.13,1.22-.39v1.6Zm12.21.11h-1.87v-6.74c0-2.44-.91-3.65-2.72-3.65-.91,0-1.68.35-2.31,1.06-.62.7-.94,1.6-.94,2.71v6.62h-1.87v-17.31h1.87v7.56h.05c.9-1.48,2.18-2.22,3.84-2.22,2.63,0,3.95,1.59,3.95,4.76v7.21Z" />
				<path d="m418.2,633.68l-2.94,10.42h-1.43l-2.14-7.61c-.09-.32-.15-.68-.17-1.06h-.03c-.03.36-.09.71-.19,1.05l-2.16,7.63h-1.42l-3.05-10.42h1.34l2.22,7.99c.09.33.15.68.17,1.05h.04c.02-.26.1-.61.23-1.05l2.3-7.99h1.17l2.21,8.05c.08.28.14.6.17.97h.03c.02-.25.08-.59.2-1l2.13-8.02h1.32Z" />
				<polygon points="424.28 633.68 419.28 645.83 418.17 645.83 423.15 633.68 424.28 633.68" />
				<path d="m425.49,644.1v-10.42h2.88c3.67,0,5.51,1.69,5.51,5.08,0,1.61-.51,2.9-1.53,3.88-1.02.97-2.38,1.46-4.09,1.46h-2.76Zm1.22-9.31v8.21h1.55c1.37,0,2.43-.37,3.19-1.1.76-.73,1.14-1.77,1.14-3.11,0-2.67-1.42-4-4.26-4h-1.63Z" />
			</g>
		</g>
	)
}

export default PlanK
